import { s as En, o as wn } from "./default-CxnxcUBG.js";
const $t = {};
function Zt(n, r) {
  const t = $t, e = typeof t.includeImageAlt == "boolean" ? t.includeImageAlt : !0, u = typeof t.includeHtml == "boolean" ? t.includeHtml : !0;
  return mt(n, e, u);
}
function mt(n, r, t) {
  if (Gt(n)) {
    if ("value" in n)
      return n.type === "html" && !t ? "" : n.value;
    if (r && "alt" in n && n.alt)
      return n.alt;
    if ("children" in n)
      return Kn(n.children, r, t);
  }
  return Array.isArray(n) ? Kn(n, r, t) : "";
}
function Kn(n, r, t) {
  const e = [];
  let u = -1;
  for (; ++u < n.length; )
    e[u] = mt(n[u], r, t);
  return e.join("");
}
function Gt(n) {
  return !!(n && typeof n == "object");
}
const vn = document.createElement("i");
function Wn(n) {
  const r = "&" + n + ";";
  vn.innerHTML = r;
  const t = vn.textContent;
  return t.charCodeAt(t.length - 1) === 59 && n !== "semi" || t === r ? !1 : t;
}
function X(n, r, t, e) {
  const u = n.length;
  let l = 0, i;
  if (r < 0 ? r = -r > u ? 0 : u + r : r = r > u ? u : r, t = t > 0 ? t : 0, e.length < 1e4)
    i = Array.from(e), i.unshift(r, t), n.splice(...i);
  else
    for (t && n.splice(r, t); l < e.length; )
      i = e.slice(l, l + 1e4), i.unshift(r, 0), n.splice(...i), l += 1e4, r += 1e4;
}
function J(n, r) {
  return n.length > 0 ? (X(n, n.length, 0, r), n) : r;
}
const nt = {}.hasOwnProperty;
function gt(n) {
  const r = {};
  let t = -1;
  for (; ++t < n.length; )
    Yt(r, n[t]);
  return r;
}
function Yt(n, r) {
  let t;
  for (t in r) {
    const u = (nt.call(n, t) ? n[t] : void 0) || (n[t] = {}), l = r[t];
    let i;
    if (l)
      for (i in l) {
        nt.call(u, i) || (u[i] = []);
        const a = l[i];
        Xt(
          // @ts-expect-error Looks like a list.
          u[i],
          Array.isArray(a) ? a : a ? [a] : []
        );
      }
  }
}
function Xt(n, r) {
  let t = -1;
  const e = [];
  for (; ++t < r.length; )
    (r[t].add === "after" ? n : e).push(r[t]);
  X(n, 0, 0, e);
}
function kt(n, r) {
  const t = Number.parseInt(n, r);
  return (
    // C0 except for HT, LF, FF, CR, space.
    t < 9 || t === 11 || t > 13 && t < 32 || // Control character (DEL) of C0, and C1 controls.
    t > 126 && t < 160 || // Lone high surrogates and low surrogates.
    t > 55295 && t < 57344 || // Noncharacters.
    t > 64975 && t < 65008 || /* eslint-disable no-bitwise */
    (t & 65535) === 65535 || (t & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    t > 1114111 ? "�" : String.fromCodePoint(t)
  );
}
function en(n) {
  return n.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const $ = fn(/[A-Za-z]/), G = fn(/[\dA-Za-z]/), Jt = fn(/[#-'*+\--9=?A-Z^-~]/);
function Ln(n) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    n !== null && (n < 32 || n === 127)
  );
}
const qn = fn(/\d/), Kt = fn(/[\dA-Fa-f]/), vt = fn(/[!-/:-@[-`{-~]/);
function F(n) {
  return n !== null && n < -2;
}
function q(n) {
  return n !== null && (n < 0 || n === 32);
}
function E(n) {
  return n === -2 || n === -1 || n === 32;
}
const On = fn(new RegExp("\\p{P}|\\p{S}", "u")), xn = fn(/\s/);
function fn(n) {
  return r;
  function r(t) {
    return t !== null && t > -1 && n.test(String.fromCharCode(t));
  }
}
function O(n, r, t, e) {
  const u = e ? e - 1 : Number.POSITIVE_INFINITY;
  let l = 0;
  return i;
  function i(c) {
    return E(c) ? (n.enter(t), a(c)) : r(c);
  }
  function a(c) {
    return E(c) && l++ < u ? (n.consume(c), a) : (n.exit(t), r(c));
  }
}
const ne = {
  tokenize: te
};
function te(n) {
  const r = n.attempt(
    this.parser.constructs.contentInitial,
    e,
    u
  );
  let t;
  return r;
  function e(a) {
    if (a === null) {
      n.consume(a);
      return;
    }
    return n.enter("lineEnding"), n.consume(a), n.exit("lineEnding"), O(n, r, "linePrefix");
  }
  function u(a) {
    return n.enter("paragraph"), l(a);
  }
  function l(a) {
    const c = n.enter("chunkText", {
      contentType: "text",
      previous: t
    });
    return t && (t.next = c), t = c, i(a);
  }
  function i(a) {
    if (a === null) {
      n.exit("chunkText"), n.exit("paragraph"), n.consume(a);
      return;
    }
    return F(a) ? (n.consume(a), n.exit("chunkText"), l) : (n.consume(a), i);
  }
}
const ee = {
  tokenize: re
}, tt = {
  tokenize: ie
};
function re(n) {
  const r = this, t = [];
  let e = 0, u, l, i;
  return a;
  function a(S) {
    if (e < t.length) {
      const P = t[e];
      return r.containerState = P[1], n.attempt(
        P[0].continuation,
        c,
        s
      )(S);
    }
    return s(S);
  }
  function c(S) {
    if (e++, r.containerState._closeFlow) {
      r.containerState._closeFlow = void 0, u && L();
      const P = r.events.length;
      let M = P, y;
      for (; M--; )
        if (r.events[M][0] === "exit" && r.events[M][1].type === "chunkFlow") {
          y = r.events[M][1].end;
          break;
        }
      d(e);
      let _ = P;
      for (; _ < r.events.length; )
        r.events[_][1].end = Object.assign({}, y), _++;
      return X(
        r.events,
        M + 1,
        0,
        r.events.slice(P)
      ), r.events.length = _, s(S);
    }
    return a(S);
  }
  function s(S) {
    if (e === t.length) {
      if (!u)
        return g(S);
      if (u.currentConstruct && u.currentConstruct.concrete)
        return b(S);
      r.interrupt = !!(u.currentConstruct && !u._gfmTableDynamicInterruptHack);
    }
    return r.containerState = {}, n.check(
      tt,
      m,
      o
    )(S);
  }
  function m(S) {
    return u && L(), d(e), g(S);
  }
  function o(S) {
    return r.parser.lazy[r.now().line] = e !== t.length, i = r.now().offset, b(S);
  }
  function g(S) {
    return r.containerState = {}, n.attempt(
      tt,
      h,
      b
    )(S);
  }
  function h(S) {
    return e++, t.push([r.currentConstruct, r.containerState]), g(S);
  }
  function b(S) {
    if (S === null) {
      u && L(), d(0), n.consume(S);
      return;
    }
    return u = u || r.parser.flow(r.now()), n.enter("chunkFlow", {
      contentType: "flow",
      previous: l,
      _tokenizer: u
    }), I(S);
  }
  function I(S) {
    if (S === null) {
      T(n.exit("chunkFlow"), !0), d(0), n.consume(S);
      return;
    }
    return F(S) ? (n.consume(S), T(n.exit("chunkFlow")), e = 0, r.interrupt = void 0, a) : (n.consume(S), I);
  }
  function T(S, P) {
    const M = r.sliceStream(S);
    if (P && M.push(null), S.previous = l, l && (l.next = S), l = S, u.defineSkip(S.start), u.write(M), r.parser.lazy[S.start.line]) {
      let y = u.events.length;
      for (; y--; )
        if (
          // The token starts before the line ending…
          u.events[y][1].start.offset < i && // …and either is not ended yet…
          (!u.events[y][1].end || // …or ends after it.
          u.events[y][1].end.offset > i)
        )
          return;
      const _ = r.events.length;
      let N = _, R, k;
      for (; N--; )
        if (r.events[N][0] === "exit" && r.events[N][1].type === "chunkFlow") {
          if (R) {
            k = r.events[N][1].end;
            break;
          }
          R = !0;
        }
      for (d(e), y = _; y < r.events.length; )
        r.events[y][1].end = Object.assign({}, k), y++;
      X(
        r.events,
        N + 1,
        0,
        r.events.slice(_)
      ), r.events.length = y;
    }
  }
  function d(S) {
    let P = t.length;
    for (; P-- > S; ) {
      const M = t[P];
      r.containerState = M[1], M[0].exit.call(r, n);
    }
    t.length = S;
  }
  function L() {
    u.write([null]), l = void 0, u = void 0, r.containerState._closeFlow = void 0;
  }
}
function ie(n, r, t) {
  return O(
    n,
    n.attempt(this.parser.constructs.document, r, t),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function Dn(n) {
  if (n === null || q(n) || xn(n))
    return 1;
  if (On(n))
    return 2;
}
function Pn(n, r, t) {
  const e = [];
  let u = -1;
  for (; ++u < n.length; ) {
    const l = n[u].resolveAll;
    l && !e.includes(l) && (r = l(r, t), e.push(l));
  }
  return r;
}
const Nn = {
  name: "attention",
  tokenize: le,
  resolveAll: ue
};
function ue(n, r) {
  let t = -1, e, u, l, i, a, c, s, m;
  for (; ++t < n.length; )
    if (n[t][0] === "enter" && n[t][1].type === "attentionSequence" && n[t][1]._close) {
      for (e = t; e--; )
        if (n[e][0] === "exit" && n[e][1].type === "attentionSequence" && n[e][1]._open && // If the markers are the same:
        r.sliceSerialize(n[e][1]).charCodeAt(0) === r.sliceSerialize(n[t][1]).charCodeAt(0)) {
          if ((n[e][1]._close || n[t][1]._open) && (n[t][1].end.offset - n[t][1].start.offset) % 3 && !((n[e][1].end.offset - n[e][1].start.offset + n[t][1].end.offset - n[t][1].start.offset) % 3))
            continue;
          c = n[e][1].end.offset - n[e][1].start.offset > 1 && n[t][1].end.offset - n[t][1].start.offset > 1 ? 2 : 1;
          const o = Object.assign({}, n[e][1].end), g = Object.assign({}, n[t][1].start);
          et(o, -c), et(g, c), i = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: o,
            end: Object.assign({}, n[e][1].end)
          }, a = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, n[t][1].start),
            end: g
          }, l = {
            type: c > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, n[e][1].end),
            end: Object.assign({}, n[t][1].start)
          }, u = {
            type: c > 1 ? "strong" : "emphasis",
            start: Object.assign({}, i.start),
            end: Object.assign({}, a.end)
          }, n[e][1].end = Object.assign({}, i.start), n[t][1].start = Object.assign({}, a.end), s = [], n[e][1].end.offset - n[e][1].start.offset && (s = J(s, [
            ["enter", n[e][1], r],
            ["exit", n[e][1], r]
          ])), s = J(s, [
            ["enter", u, r],
            ["enter", i, r],
            ["exit", i, r],
            ["enter", l, r]
          ]), s = J(
            s,
            Pn(
              r.parser.constructs.insideSpan.null,
              n.slice(e + 1, t),
              r
            )
          ), s = J(s, [
            ["exit", l, r],
            ["enter", a, r],
            ["exit", a, r],
            ["exit", u, r]
          ]), n[t][1].end.offset - n[t][1].start.offset ? (m = 2, s = J(s, [
            ["enter", n[t][1], r],
            ["exit", n[t][1], r]
          ])) : m = 0, X(n, e - 1, t - e + 3, s), t = e + s.length - m - 2;
          break;
        }
    }
  for (t = -1; ++t < n.length; )
    n[t][1].type === "attentionSequence" && (n[t][1].type = "data");
  return n;
}
function le(n, r) {
  const t = this.parser.constructs.attentionMarkers.null, e = this.previous, u = Dn(e);
  let l;
  return i;
  function i(c) {
    return l = c, n.enter("attentionSequence"), a(c);
  }
  function a(c) {
    if (c === l)
      return n.consume(c), a;
    const s = n.exit("attentionSequence"), m = Dn(c), o = !m || m === 2 && u || t.includes(c), g = !u || u === 2 && m || t.includes(e);
    return s._open = !!(l === 42 ? o : o && (u || !g)), s._close = !!(l === 42 ? g : g && (m || !o)), r(c);
  }
}
function et(n, r) {
  n.column += r, n.offset += r, n._bufferIndex += r;
}
const ae = {
  name: "autolink",
  tokenize: oe
};
function oe(n, r, t) {
  let e = 0;
  return u;
  function u(h) {
    return n.enter("autolink"), n.enter("autolinkMarker"), n.consume(h), n.exit("autolinkMarker"), n.enter("autolinkProtocol"), l;
  }
  function l(h) {
    return $(h) ? (n.consume(h), i) : s(h);
  }
  function i(h) {
    return h === 43 || h === 45 || h === 46 || G(h) ? (e = 1, a(h)) : s(h);
  }
  function a(h) {
    return h === 58 ? (n.consume(h), e = 0, c) : (h === 43 || h === 45 || h === 46 || G(h)) && e++ < 32 ? (n.consume(h), a) : (e = 0, s(h));
  }
  function c(h) {
    return h === 62 ? (n.exit("autolinkProtocol"), n.enter("autolinkMarker"), n.consume(h), n.exit("autolinkMarker"), n.exit("autolink"), r) : h === null || h === 32 || h === 60 || Ln(h) ? t(h) : (n.consume(h), c);
  }
  function s(h) {
    return h === 64 ? (n.consume(h), m) : Jt(h) ? (n.consume(h), s) : t(h);
  }
  function m(h) {
    return G(h) ? o(h) : t(h);
  }
  function o(h) {
    return h === 46 ? (n.consume(h), e = 0, m) : h === 62 ? (n.exit("autolinkProtocol").type = "autolinkEmail", n.enter("autolinkMarker"), n.consume(h), n.exit("autolinkMarker"), n.exit("autolink"), r) : g(h);
  }
  function g(h) {
    if ((h === 45 || G(h)) && e++ < 63) {
      const b = h === 45 ? g : o;
      return n.consume(h), b;
    }
    return t(h);
  }
}
const In = {
  tokenize: se,
  partial: !0
};
function se(n, r, t) {
  return e;
  function e(l) {
    return E(l) ? O(n, u, "linePrefix")(l) : u(l);
  }
  function u(l) {
    return l === null || F(l) ? r(l) : t(l);
  }
}
const xt = {
  name: "blockQuote",
  tokenize: ce,
  continuation: {
    tokenize: he
  },
  exit: fe
};
function ce(n, r, t) {
  const e = this;
  return u;
  function u(i) {
    if (i === 62) {
      const a = e.containerState;
      return a.open || (n.enter("blockQuote", {
        _container: !0
      }), a.open = !0), n.enter("blockQuotePrefix"), n.enter("blockQuoteMarker"), n.consume(i), n.exit("blockQuoteMarker"), l;
    }
    return t(i);
  }
  function l(i) {
    return E(i) ? (n.enter("blockQuotePrefixWhitespace"), n.consume(i), n.exit("blockQuotePrefixWhitespace"), n.exit("blockQuotePrefix"), r) : (n.exit("blockQuotePrefix"), r(i));
  }
}
function he(n, r, t) {
  const e = this;
  return u;
  function u(i) {
    return E(i) ? O(
      n,
      l,
      "linePrefix",
      e.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(i) : l(i);
  }
  function l(i) {
    return n.attempt(xt, r, t)(i);
  }
}
function fe(n) {
  n.exit("blockQuote");
}
const bt = {
  name: "characterEscape",
  tokenize: pe
};
function pe(n, r, t) {
  return e;
  function e(l) {
    return n.enter("characterEscape"), n.enter("escapeMarker"), n.consume(l), n.exit("escapeMarker"), u;
  }
  function u(l) {
    return vt(l) ? (n.enter("characterEscapeValue"), n.consume(l), n.exit("characterEscapeValue"), n.exit("characterEscape"), r) : t(l);
  }
}
const yt = {
  name: "characterReference",
  tokenize: me
};
function me(n, r, t) {
  const e = this;
  let u = 0, l, i;
  return a;
  function a(o) {
    return n.enter("characterReference"), n.enter("characterReferenceMarker"), n.consume(o), n.exit("characterReferenceMarker"), c;
  }
  function c(o) {
    return o === 35 ? (n.enter("characterReferenceMarkerNumeric"), n.consume(o), n.exit("characterReferenceMarkerNumeric"), s) : (n.enter("characterReferenceValue"), l = 31, i = G, m(o));
  }
  function s(o) {
    return o === 88 || o === 120 ? (n.enter("characterReferenceMarkerHexadecimal"), n.consume(o), n.exit("characterReferenceMarkerHexadecimal"), n.enter("characterReferenceValue"), l = 6, i = Kt, m) : (n.enter("characterReferenceValue"), l = 7, i = qn, m(o));
  }
  function m(o) {
    if (o === 59 && u) {
      const g = n.exit("characterReferenceValue");
      return i === G && !Wn(e.sliceSerialize(g)) ? t(o) : (n.enter("characterReferenceMarker"), n.consume(o), n.exit("characterReferenceMarker"), n.exit("characterReference"), r);
    }
    return i(o) && u++ < l ? (n.consume(o), m) : t(o);
  }
}
const rt = {
  tokenize: ke,
  partial: !0
}, it = {
  name: "codeFenced",
  tokenize: ge,
  concrete: !0
};
function ge(n, r, t) {
  const e = this, u = {
    tokenize: M,
    partial: !0
  };
  let l = 0, i = 0, a;
  return c;
  function c(y) {
    return s(y);
  }
  function s(y) {
    const _ = e.events[e.events.length - 1];
    return l = _ && _[1].type === "linePrefix" ? _[2].sliceSerialize(_[1], !0).length : 0, a = y, n.enter("codeFenced"), n.enter("codeFencedFence"), n.enter("codeFencedFenceSequence"), m(y);
  }
  function m(y) {
    return y === a ? (i++, n.consume(y), m) : i < 3 ? t(y) : (n.exit("codeFencedFenceSequence"), E(y) ? O(n, o, "whitespace")(y) : o(y));
  }
  function o(y) {
    return y === null || F(y) ? (n.exit("codeFencedFence"), e.interrupt ? r(y) : n.check(rt, I, P)(y)) : (n.enter("codeFencedFenceInfo"), n.enter("chunkString", {
      contentType: "string"
    }), g(y));
  }
  function g(y) {
    return y === null || F(y) ? (n.exit("chunkString"), n.exit("codeFencedFenceInfo"), o(y)) : E(y) ? (n.exit("chunkString"), n.exit("codeFencedFenceInfo"), O(n, h, "whitespace")(y)) : y === 96 && y === a ? t(y) : (n.consume(y), g);
  }
  function h(y) {
    return y === null || F(y) ? o(y) : (n.enter("codeFencedFenceMeta"), n.enter("chunkString", {
      contentType: "string"
    }), b(y));
  }
  function b(y) {
    return y === null || F(y) ? (n.exit("chunkString"), n.exit("codeFencedFenceMeta"), o(y)) : y === 96 && y === a ? t(y) : (n.consume(y), b);
  }
  function I(y) {
    return n.attempt(u, P, T)(y);
  }
  function T(y) {
    return n.enter("lineEnding"), n.consume(y), n.exit("lineEnding"), d;
  }
  function d(y) {
    return l > 0 && E(y) ? O(
      n,
      L,
      "linePrefix",
      l + 1
    )(y) : L(y);
  }
  function L(y) {
    return y === null || F(y) ? n.check(rt, I, P)(y) : (n.enter("codeFlowValue"), S(y));
  }
  function S(y) {
    return y === null || F(y) ? (n.exit("codeFlowValue"), L(y)) : (n.consume(y), S);
  }
  function P(y) {
    return n.exit("codeFenced"), r(y);
  }
  function M(y, _, N) {
    let R = 0;
    return k;
    function k(B) {
      return y.enter("lineEnding"), y.consume(B), y.exit("lineEnding"), C;
    }
    function C(B) {
      return y.enter("codeFencedFence"), E(B) ? O(
        y,
        z,
        "linePrefix",
        e.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(B) : z(B);
    }
    function z(B) {
      return B === a ? (y.enter("codeFencedFenceSequence"), H(B)) : N(B);
    }
    function H(B) {
      return B === a ? (R++, y.consume(B), H) : R >= i ? (y.exit("codeFencedFenceSequence"), E(B) ? O(y, V, "whitespace")(B) : V(B)) : N(B);
    }
    function V(B) {
      return B === null || F(B) ? (y.exit("codeFencedFence"), _(B)) : N(B);
    }
  }
}
function ke(n, r, t) {
  const e = this;
  return u;
  function u(i) {
    return i === null ? t(i) : (n.enter("lineEnding"), n.consume(i), n.exit("lineEnding"), l);
  }
  function l(i) {
    return e.parser.lazy[e.now().line] ? t(i) : r(i);
  }
}
const Mn = {
  name: "codeIndented",
  tokenize: be
}, xe = {
  tokenize: ye,
  partial: !0
};
function be(n, r, t) {
  const e = this;
  return u;
  function u(s) {
    return n.enter("codeIndented"), O(n, l, "linePrefix", 5)(s);
  }
  function l(s) {
    const m = e.events[e.events.length - 1];
    return m && m[1].type === "linePrefix" && m[2].sliceSerialize(m[1], !0).length >= 4 ? i(s) : t(s);
  }
  function i(s) {
    return s === null ? c(s) : F(s) ? n.attempt(xe, i, c)(s) : (n.enter("codeFlowValue"), a(s));
  }
  function a(s) {
    return s === null || F(s) ? (n.exit("codeFlowValue"), i(s)) : (n.consume(s), a);
  }
  function c(s) {
    return n.exit("codeIndented"), r(s);
  }
}
function ye(n, r, t) {
  const e = this;
  return u;
  function u(i) {
    return e.parser.lazy[e.now().line] ? t(i) : F(i) ? (n.enter("lineEnding"), n.consume(i), n.exit("lineEnding"), u) : O(n, l, "linePrefix", 5)(i);
  }
  function l(i) {
    const a = e.events[e.events.length - 1];
    return a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? r(i) : F(i) ? u(i) : t(i);
  }
}
const de = {
  name: "codeText",
  tokenize: Ce,
  resolve: we,
  previous: Se
};
function we(n) {
  let r = n.length - 4, t = 3, e, u;
  if ((n[t][1].type === "lineEnding" || n[t][1].type === "space") && (n[r][1].type === "lineEnding" || n[r][1].type === "space")) {
    for (e = t; ++e < r; )
      if (n[e][1].type === "codeTextData") {
        n[t][1].type = "codeTextPadding", n[r][1].type = "codeTextPadding", t += 2, r -= 2;
        break;
      }
  }
  for (e = t - 1, r++; ++e <= r; )
    u === void 0 ? e !== r && n[e][1].type !== "lineEnding" && (u = e) : (e === r || n[e][1].type === "lineEnding") && (n[u][1].type = "codeTextData", e !== u + 2 && (n[u][1].end = n[e - 1][1].end, n.splice(u + 2, e - u - 2), r -= e - u - 2, e = u + 2), u = void 0);
  return n;
}
function Se(n) {
  return n !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Ce(n, r, t) {
  let e = 0, u, l;
  return i;
  function i(o) {
    return n.enter("codeText"), n.enter("codeTextSequence"), a(o);
  }
  function a(o) {
    return o === 96 ? (n.consume(o), e++, a) : (n.exit("codeTextSequence"), c(o));
  }
  function c(o) {
    return o === null ? t(o) : o === 32 ? (n.enter("space"), n.consume(o), n.exit("space"), c) : o === 96 ? (l = n.enter("codeTextSequence"), u = 0, m(o)) : F(o) ? (n.enter("lineEnding"), n.consume(o), n.exit("lineEnding"), c) : (n.enter("codeTextData"), s(o));
  }
  function s(o) {
    return o === null || o === 32 || o === 96 || F(o) ? (n.exit("codeTextData"), c(o)) : (n.consume(o), s);
  }
  function m(o) {
    return o === 96 ? (n.consume(o), u++, m) : u === e ? (n.exit("codeTextSequence"), n.exit("codeText"), r(o)) : (l.type = "codeTextData", s(o));
  }
}
function dt(n) {
  const r = {};
  let t = -1, e, u, l, i, a, c, s;
  for (; ++t < n.length; ) {
    for (; t in r; )
      t = r[t];
    if (e = n[t], t && e[1].type === "chunkFlow" && n[t - 1][1].type === "listItemPrefix" && (c = e[1]._tokenizer.events, l = 0, l < c.length && c[l][1].type === "lineEndingBlank" && (l += 2), l < c.length && c[l][1].type === "content"))
      for (; ++l < c.length && c[l][1].type !== "content"; )
        c[l][1].type === "chunkText" && (c[l][1]._isInFirstContentOfListItem = !0, l++);
    if (e[0] === "enter")
      e[1].contentType && (Object.assign(r, ze(n, t)), t = r[t], s = !0);
    else if (e[1]._container) {
      for (l = t, u = void 0; l-- && (i = n[l], i[1].type === "lineEnding" || i[1].type === "lineEndingBlank"); )
        i[0] === "enter" && (u && (n[u][1].type = "lineEndingBlank"), i[1].type = "lineEnding", u = l);
      u && (e[1].end = Object.assign({}, n[u][1].start), a = n.slice(u, t), a.unshift(e), X(n, u, t - u + 1, a));
    }
  }
  return !s;
}
function ze(n, r) {
  const t = n[r][1], e = n[r][2];
  let u = r - 1;
  const l = [], i = t._tokenizer || e.parser[t.contentType](t.start), a = i.events, c = [], s = {};
  let m, o, g = -1, h = t, b = 0, I = 0;
  const T = [I];
  for (; h; ) {
    for (; n[++u][1] !== h; )
      ;
    l.push(u), h._tokenizer || (m = e.sliceStream(h), h.next || m.push(null), o && i.defineSkip(h.start), h._isInFirstContentOfListItem && (i._gfmTasklistFirstContentOfListItem = !0), i.write(m), h._isInFirstContentOfListItem && (i._gfmTasklistFirstContentOfListItem = void 0)), o = h, h = h.next;
  }
  for (h = t; ++g < a.length; )
    // Find a void token that includes a break.
    a[g][0] === "exit" && a[g - 1][0] === "enter" && a[g][1].type === a[g - 1][1].type && a[g][1].start.line !== a[g][1].end.line && (I = g + 1, T.push(I), h._tokenizer = void 0, h.previous = void 0, h = h.next);
  for (i.events = [], h ? (h._tokenizer = void 0, h.previous = void 0) : T.pop(), g = T.length; g--; ) {
    const d = a.slice(T[g], T[g + 1]), L = l.pop();
    c.unshift([L, L + d.length - 1]), X(n, L, 2, d);
  }
  for (g = -1; ++g < c.length; )
    s[b + c[g][0]] = b + c[g][1], b += c[g][1] - c[g][0] - 1;
  return s;
}
const Fe = {
  tokenize: Ee,
  resolve: Ae
}, Ie = {
  tokenize: Te,
  partial: !0
};
function Ae(n) {
  return dt(n), n;
}
function Ee(n, r) {
  let t;
  return e;
  function e(a) {
    return n.enter("content"), t = n.enter("chunkContent", {
      contentType: "content"
    }), u(a);
  }
  function u(a) {
    return a === null ? l(a) : F(a) ? n.check(
      Ie,
      i,
      l
    )(a) : (n.consume(a), u);
  }
  function l(a) {
    return n.exit("chunkContent"), n.exit("content"), r(a);
  }
  function i(a) {
    return n.consume(a), n.exit("chunkContent"), t.next = n.enter("chunkContent", {
      contentType: "content",
      previous: t
    }), t = t.next, u;
  }
}
function Te(n, r, t) {
  const e = this;
  return u;
  function u(i) {
    return n.exit("chunkContent"), n.enter("lineEnding"), n.consume(i), n.exit("lineEnding"), O(n, l, "linePrefix");
  }
  function l(i) {
    if (i === null || F(i))
      return t(i);
    const a = e.events[e.events.length - 1];
    return !e.parser.constructs.disable.null.includes("codeIndented") && a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? r(i) : n.interrupt(e.parser.constructs.flow, t, r)(i);
  }
}
function wt(n, r, t, e, u, l, i, a, c) {
  const s = c || Number.POSITIVE_INFINITY;
  let m = 0;
  return o;
  function o(d) {
    return d === 60 ? (n.enter(e), n.enter(u), n.enter(l), n.consume(d), n.exit(l), g) : d === null || d === 32 || d === 41 || Ln(d) ? t(d) : (n.enter(e), n.enter(i), n.enter(a), n.enter("chunkString", {
      contentType: "string"
    }), I(d));
  }
  function g(d) {
    return d === 62 ? (n.enter(l), n.consume(d), n.exit(l), n.exit(u), n.exit(e), r) : (n.enter(a), n.enter("chunkString", {
      contentType: "string"
    }), h(d));
  }
  function h(d) {
    return d === 62 ? (n.exit("chunkString"), n.exit(a), g(d)) : d === null || d === 60 || F(d) ? t(d) : (n.consume(d), d === 92 ? b : h);
  }
  function b(d) {
    return d === 60 || d === 62 || d === 92 ? (n.consume(d), h) : h(d);
  }
  function I(d) {
    return !m && (d === null || d === 41 || q(d)) ? (n.exit("chunkString"), n.exit(a), n.exit(i), n.exit(e), r(d)) : m < s && d === 40 ? (n.consume(d), m++, I) : d === 41 ? (n.consume(d), m--, I) : d === null || d === 32 || d === 40 || Ln(d) ? t(d) : (n.consume(d), d === 92 ? T : I);
  }
  function T(d) {
    return d === 40 || d === 41 || d === 92 ? (n.consume(d), I) : I(d);
  }
}
function St(n, r, t, e, u, l) {
  const i = this;
  let a = 0, c;
  return s;
  function s(h) {
    return n.enter(e), n.enter(u), n.consume(h), n.exit(u), n.enter(l), m;
  }
  function m(h) {
    return a > 999 || h === null || h === 91 || h === 93 && !c || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    h === 94 && !a && "_hiddenFootnoteSupport" in i.parser.constructs ? t(h) : h === 93 ? (n.exit(l), n.enter(u), n.consume(h), n.exit(u), n.exit(e), r) : F(h) ? (n.enter("lineEnding"), n.consume(h), n.exit("lineEnding"), m) : (n.enter("chunkString", {
      contentType: "string"
    }), o(h));
  }
  function o(h) {
    return h === null || h === 91 || h === 93 || F(h) || a++ > 999 ? (n.exit("chunkString"), m(h)) : (n.consume(h), c || (c = !E(h)), h === 92 ? g : o);
  }
  function g(h) {
    return h === 91 || h === 92 || h === 93 ? (n.consume(h), a++, o) : o(h);
  }
}
function Ct(n, r, t, e, u, l) {
  let i;
  return a;
  function a(g) {
    return g === 34 || g === 39 || g === 40 ? (n.enter(e), n.enter(u), n.consume(g), n.exit(u), i = g === 40 ? 41 : g, c) : t(g);
  }
  function c(g) {
    return g === i ? (n.enter(u), n.consume(g), n.exit(u), n.exit(e), r) : (n.enter(l), s(g));
  }
  function s(g) {
    return g === i ? (n.exit(l), c(i)) : g === null ? t(g) : F(g) ? (n.enter("lineEnding"), n.consume(g), n.exit("lineEnding"), O(n, s, "linePrefix")) : (n.enter("chunkString", {
      contentType: "string"
    }), m(g));
  }
  function m(g) {
    return g === i || g === null || F(g) ? (n.exit("chunkString"), s(g)) : (n.consume(g), g === 92 ? o : m);
  }
  function o(g) {
    return g === i || g === 92 ? (n.consume(g), m) : m(g);
  }
}
function Fn(n, r) {
  let t;
  return e;
  function e(u) {
    return F(u) ? (n.enter("lineEnding"), n.consume(u), n.exit("lineEnding"), t = !0, e) : E(u) ? O(
      n,
      e,
      t ? "linePrefix" : "lineSuffix"
    )(u) : r(u);
  }
}
const Le = {
  name: "definition",
  tokenize: Oe
}, De = {
  tokenize: Pe,
  partial: !0
};
function Oe(n, r, t) {
  const e = this;
  let u;
  return l;
  function l(h) {
    return n.enter("definition"), i(h);
  }
  function i(h) {
    return St.call(
      e,
      n,
      a,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(h);
  }
  function a(h) {
    return u = en(
      e.sliceSerialize(e.events[e.events.length - 1][1]).slice(1, -1)
    ), h === 58 ? (n.enter("definitionMarker"), n.consume(h), n.exit("definitionMarker"), c) : t(h);
  }
  function c(h) {
    return q(h) ? Fn(n, s)(h) : s(h);
  }
  function s(h) {
    return wt(
      n,
      m,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(h);
  }
  function m(h) {
    return n.attempt(De, o, o)(h);
  }
  function o(h) {
    return E(h) ? O(n, g, "whitespace")(h) : g(h);
  }
  function g(h) {
    return h === null || F(h) ? (n.exit("definition"), e.parser.defined.push(u), r(h)) : t(h);
  }
}
function Pe(n, r, t) {
  return e;
  function e(a) {
    return q(a) ? Fn(n, u)(a) : t(a);
  }
  function u(a) {
    return Ct(
      n,
      l,
      t,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(a);
  }
  function l(a) {
    return E(a) ? O(n, i, "whitespace")(a) : i(a);
  }
  function i(a) {
    return a === null || F(a) ? r(a) : t(a);
  }
}
const _e = {
  name: "hardBreakEscape",
  tokenize: Be
};
function Be(n, r, t) {
  return e;
  function e(l) {
    return n.enter("hardBreakEscape"), n.consume(l), u;
  }
  function u(l) {
    return F(l) ? (n.exit("hardBreakEscape"), r(l)) : t(l);
  }
}
const Me = {
  name: "headingAtx",
  tokenize: je,
  resolve: Re
};
function Re(n, r) {
  let t = n.length - 2, e = 3, u, l;
  return n[e][1].type === "whitespace" && (e += 2), t - 2 > e && n[t][1].type === "whitespace" && (t -= 2), n[t][1].type === "atxHeadingSequence" && (e === t - 1 || t - 4 > e && n[t - 2][1].type === "whitespace") && (t -= e + 1 === t ? 2 : 4), t > e && (u = {
    type: "atxHeadingText",
    start: n[e][1].start,
    end: n[t][1].end
  }, l = {
    type: "chunkText",
    start: n[e][1].start,
    end: n[t][1].end,
    contentType: "text"
  }, X(n, e, t - e + 1, [
    ["enter", u, r],
    ["enter", l, r],
    ["exit", l, r],
    ["exit", u, r]
  ])), n;
}
function je(n, r, t) {
  let e = 0;
  return u;
  function u(m) {
    return n.enter("atxHeading"), l(m);
  }
  function l(m) {
    return n.enter("atxHeadingSequence"), i(m);
  }
  function i(m) {
    return m === 35 && e++ < 6 ? (n.consume(m), i) : m === null || q(m) ? (n.exit("atxHeadingSequence"), a(m)) : t(m);
  }
  function a(m) {
    return m === 35 ? (n.enter("atxHeadingSequence"), c(m)) : m === null || F(m) ? (n.exit("atxHeading"), r(m)) : E(m) ? O(n, a, "whitespace")(m) : (n.enter("atxHeadingText"), s(m));
  }
  function c(m) {
    return m === 35 ? (n.consume(m), c) : (n.exit("atxHeadingSequence"), a(m));
  }
  function s(m) {
    return m === null || m === 35 || q(m) ? (n.exit("atxHeadingText"), a(m)) : (n.consume(m), s);
  }
}
const He = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], ut = ["pre", "script", "style", "textarea"], qe = {
  name: "htmlFlow",
  tokenize: Qe,
  resolveTo: We,
  concrete: !0
}, Ne = {
  tokenize: $e,
  partial: !0
}, Ve = {
  tokenize: Ue,
  partial: !0
};
function We(n) {
  let r = n.length;
  for (; r-- && !(n[r][0] === "enter" && n[r][1].type === "htmlFlow"); )
    ;
  return r > 1 && n[r - 2][1].type === "linePrefix" && (n[r][1].start = n[r - 2][1].start, n[r + 1][1].start = n[r - 2][1].start, n.splice(r - 2, 2)), n;
}
function Qe(n, r, t) {
  const e = this;
  let u, l, i, a, c;
  return s;
  function s(p) {
    return m(p);
  }
  function m(p) {
    return n.enter("htmlFlow"), n.enter("htmlFlowData"), n.consume(p), o;
  }
  function o(p) {
    return p === 33 ? (n.consume(p), g) : p === 47 ? (n.consume(p), l = !0, I) : p === 63 ? (n.consume(p), u = 3, e.interrupt ? r : f) : $(p) ? (n.consume(p), i = String.fromCharCode(p), T) : t(p);
  }
  function g(p) {
    return p === 45 ? (n.consume(p), u = 2, h) : p === 91 ? (n.consume(p), u = 5, a = 0, b) : $(p) ? (n.consume(p), u = 4, e.interrupt ? r : f) : t(p);
  }
  function h(p) {
    return p === 45 ? (n.consume(p), e.interrupt ? r : f) : t(p);
  }
  function b(p) {
    const nn = "CDATA[";
    return p === nn.charCodeAt(a++) ? (n.consume(p), a === nn.length ? e.interrupt ? r : z : b) : t(p);
  }
  function I(p) {
    return $(p) ? (n.consume(p), i = String.fromCharCode(p), T) : t(p);
  }
  function T(p) {
    if (p === null || p === 47 || p === 62 || q(p)) {
      const nn = p === 47, pn = i.toLowerCase();
      return !nn && !l && ut.includes(pn) ? (u = 1, e.interrupt ? r(p) : z(p)) : He.includes(i.toLowerCase()) ? (u = 6, nn ? (n.consume(p), d) : e.interrupt ? r(p) : z(p)) : (u = 7, e.interrupt && !e.parser.lazy[e.now().line] ? t(p) : l ? L(p) : S(p));
    }
    return p === 45 || G(p) ? (n.consume(p), i += String.fromCharCode(p), T) : t(p);
  }
  function d(p) {
    return p === 62 ? (n.consume(p), e.interrupt ? r : z) : t(p);
  }
  function L(p) {
    return E(p) ? (n.consume(p), L) : k(p);
  }
  function S(p) {
    return p === 47 ? (n.consume(p), k) : p === 58 || p === 95 || $(p) ? (n.consume(p), P) : E(p) ? (n.consume(p), S) : k(p);
  }
  function P(p) {
    return p === 45 || p === 46 || p === 58 || p === 95 || G(p) ? (n.consume(p), P) : M(p);
  }
  function M(p) {
    return p === 61 ? (n.consume(p), y) : E(p) ? (n.consume(p), M) : S(p);
  }
  function y(p) {
    return p === null || p === 60 || p === 61 || p === 62 || p === 96 ? t(p) : p === 34 || p === 39 ? (n.consume(p), c = p, _) : E(p) ? (n.consume(p), y) : N(p);
  }
  function _(p) {
    return p === c ? (n.consume(p), c = null, R) : p === null || F(p) ? t(p) : (n.consume(p), _);
  }
  function N(p) {
    return p === null || p === 34 || p === 39 || p === 47 || p === 60 || p === 61 || p === 62 || p === 96 || q(p) ? M(p) : (n.consume(p), N);
  }
  function R(p) {
    return p === 47 || p === 62 || E(p) ? S(p) : t(p);
  }
  function k(p) {
    return p === 62 ? (n.consume(p), C) : t(p);
  }
  function C(p) {
    return p === null || F(p) ? z(p) : E(p) ? (n.consume(p), C) : t(p);
  }
  function z(p) {
    return p === 45 && u === 2 ? (n.consume(p), U) : p === 60 && u === 1 ? (n.consume(p), W) : p === 62 && u === 4 ? (n.consume(p), v) : p === 63 && u === 3 ? (n.consume(p), f) : p === 93 && u === 5 ? (n.consume(p), un) : F(p) && (u === 6 || u === 7) ? (n.exit("htmlFlowData"), n.check(
      Ne,
      ln,
      H
    )(p)) : p === null || F(p) ? (n.exit("htmlFlowData"), H(p)) : (n.consume(p), z);
  }
  function H(p) {
    return n.check(
      Ve,
      V,
      ln
    )(p);
  }
  function V(p) {
    return n.enter("lineEnding"), n.consume(p), n.exit("lineEnding"), B;
  }
  function B(p) {
    return p === null || F(p) ? H(p) : (n.enter("htmlFlowData"), z(p));
  }
  function U(p) {
    return p === 45 ? (n.consume(p), f) : z(p);
  }
  function W(p) {
    return p === 47 ? (n.consume(p), i = "", K) : z(p);
  }
  function K(p) {
    if (p === 62) {
      const nn = i.toLowerCase();
      return ut.includes(nn) ? (n.consume(p), v) : z(p);
    }
    return $(p) && i.length < 8 ? (n.consume(p), i += String.fromCharCode(p), K) : z(p);
  }
  function un(p) {
    return p === 93 ? (n.consume(p), f) : z(p);
  }
  function f(p) {
    return p === 62 ? (n.consume(p), v) : p === 45 && u === 2 ? (n.consume(p), f) : z(p);
  }
  function v(p) {
    return p === null || F(p) ? (n.exit("htmlFlowData"), ln(p)) : (n.consume(p), v);
  }
  function ln(p) {
    return n.exit("htmlFlow"), r(p);
  }
}
function Ue(n, r, t) {
  const e = this;
  return u;
  function u(i) {
    return F(i) ? (n.enter("lineEnding"), n.consume(i), n.exit("lineEnding"), l) : t(i);
  }
  function l(i) {
    return e.parser.lazy[e.now().line] ? t(i) : r(i);
  }
}
function $e(n, r, t) {
  return e;
  function e(u) {
    return n.enter("lineEnding"), n.consume(u), n.exit("lineEnding"), n.attempt(In, r, t);
  }
}
const Ze = {
  name: "htmlText",
  tokenize: Ge
};
function Ge(n, r, t) {
  const e = this;
  let u, l, i;
  return a;
  function a(f) {
    return n.enter("htmlText"), n.enter("htmlTextData"), n.consume(f), c;
  }
  function c(f) {
    return f === 33 ? (n.consume(f), s) : f === 47 ? (n.consume(f), M) : f === 63 ? (n.consume(f), S) : $(f) ? (n.consume(f), N) : t(f);
  }
  function s(f) {
    return f === 45 ? (n.consume(f), m) : f === 91 ? (n.consume(f), l = 0, b) : $(f) ? (n.consume(f), L) : t(f);
  }
  function m(f) {
    return f === 45 ? (n.consume(f), h) : t(f);
  }
  function o(f) {
    return f === null ? t(f) : f === 45 ? (n.consume(f), g) : F(f) ? (i = o, W(f)) : (n.consume(f), o);
  }
  function g(f) {
    return f === 45 ? (n.consume(f), h) : o(f);
  }
  function h(f) {
    return f === 62 ? U(f) : f === 45 ? g(f) : o(f);
  }
  function b(f) {
    const v = "CDATA[";
    return f === v.charCodeAt(l++) ? (n.consume(f), l === v.length ? I : b) : t(f);
  }
  function I(f) {
    return f === null ? t(f) : f === 93 ? (n.consume(f), T) : F(f) ? (i = I, W(f)) : (n.consume(f), I);
  }
  function T(f) {
    return f === 93 ? (n.consume(f), d) : I(f);
  }
  function d(f) {
    return f === 62 ? U(f) : f === 93 ? (n.consume(f), d) : I(f);
  }
  function L(f) {
    return f === null || f === 62 ? U(f) : F(f) ? (i = L, W(f)) : (n.consume(f), L);
  }
  function S(f) {
    return f === null ? t(f) : f === 63 ? (n.consume(f), P) : F(f) ? (i = S, W(f)) : (n.consume(f), S);
  }
  function P(f) {
    return f === 62 ? U(f) : S(f);
  }
  function M(f) {
    return $(f) ? (n.consume(f), y) : t(f);
  }
  function y(f) {
    return f === 45 || G(f) ? (n.consume(f), y) : _(f);
  }
  function _(f) {
    return F(f) ? (i = _, W(f)) : E(f) ? (n.consume(f), _) : U(f);
  }
  function N(f) {
    return f === 45 || G(f) ? (n.consume(f), N) : f === 47 || f === 62 || q(f) ? R(f) : t(f);
  }
  function R(f) {
    return f === 47 ? (n.consume(f), U) : f === 58 || f === 95 || $(f) ? (n.consume(f), k) : F(f) ? (i = R, W(f)) : E(f) ? (n.consume(f), R) : U(f);
  }
  function k(f) {
    return f === 45 || f === 46 || f === 58 || f === 95 || G(f) ? (n.consume(f), k) : C(f);
  }
  function C(f) {
    return f === 61 ? (n.consume(f), z) : F(f) ? (i = C, W(f)) : E(f) ? (n.consume(f), C) : R(f);
  }
  function z(f) {
    return f === null || f === 60 || f === 61 || f === 62 || f === 96 ? t(f) : f === 34 || f === 39 ? (n.consume(f), u = f, H) : F(f) ? (i = z, W(f)) : E(f) ? (n.consume(f), z) : (n.consume(f), V);
  }
  function H(f) {
    return f === u ? (n.consume(f), u = void 0, B) : f === null ? t(f) : F(f) ? (i = H, W(f)) : (n.consume(f), H);
  }
  function V(f) {
    return f === null || f === 34 || f === 39 || f === 60 || f === 61 || f === 96 ? t(f) : f === 47 || f === 62 || q(f) ? R(f) : (n.consume(f), V);
  }
  function B(f) {
    return f === 47 || f === 62 || q(f) ? R(f) : t(f);
  }
  function U(f) {
    return f === 62 ? (n.consume(f), n.exit("htmlTextData"), n.exit("htmlText"), r) : t(f);
  }
  function W(f) {
    return n.exit("htmlTextData"), n.enter("lineEnding"), n.consume(f), n.exit("lineEnding"), K;
  }
  function K(f) {
    return E(f) ? O(
      n,
      un,
      "linePrefix",
      e.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(f) : un(f);
  }
  function un(f) {
    return n.enter("htmlTextData"), i(f);
  }
}
const Qn = {
  name: "labelEnd",
  tokenize: nr,
  resolveTo: ve,
  resolveAll: Ke
}, Ye = {
  tokenize: tr
}, Xe = {
  tokenize: er
}, Je = {
  tokenize: rr
};
function Ke(n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const t = n[r][1];
    (t.type === "labelImage" || t.type === "labelLink" || t.type === "labelEnd") && (n.splice(r + 1, t.type === "labelImage" ? 4 : 2), t.type = "data", r++);
  }
  return n;
}
function ve(n, r) {
  let t = n.length, e = 0, u, l, i, a;
  for (; t--; )
    if (u = n[t][1], l) {
      if (u.type === "link" || u.type === "labelLink" && u._inactive)
        break;
      n[t][0] === "enter" && u.type === "labelLink" && (u._inactive = !0);
    } else if (i) {
      if (n[t][0] === "enter" && (u.type === "labelImage" || u.type === "labelLink") && !u._balanced && (l = t, u.type !== "labelLink")) {
        e = 2;
        break;
      }
    } else u.type === "labelEnd" && (i = t);
  const c = {
    type: n[l][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, n[l][1].start),
    end: Object.assign({}, n[n.length - 1][1].end)
  }, s = {
    type: "label",
    start: Object.assign({}, n[l][1].start),
    end: Object.assign({}, n[i][1].end)
  }, m = {
    type: "labelText",
    start: Object.assign({}, n[l + e + 2][1].end),
    end: Object.assign({}, n[i - 2][1].start)
  };
  return a = [
    ["enter", c, r],
    ["enter", s, r]
  ], a = J(a, n.slice(l + 1, l + e + 3)), a = J(a, [["enter", m, r]]), a = J(
    a,
    Pn(
      r.parser.constructs.insideSpan.null,
      n.slice(l + e + 4, i - 3),
      r
    )
  ), a = J(a, [
    ["exit", m, r],
    n[i - 2],
    n[i - 1],
    ["exit", s, r]
  ]), a = J(a, n.slice(i + 1)), a = J(a, [["exit", c, r]]), X(n, l, n.length, a), n;
}
function nr(n, r, t) {
  const e = this;
  let u = e.events.length, l, i;
  for (; u--; )
    if ((e.events[u][1].type === "labelImage" || e.events[u][1].type === "labelLink") && !e.events[u][1]._balanced) {
      l = e.events[u][1];
      break;
    }
  return a;
  function a(g) {
    return l ? l._inactive ? o(g) : (i = e.parser.defined.includes(
      en(
        e.sliceSerialize({
          start: l.end,
          end: e.now()
        })
      )
    ), n.enter("labelEnd"), n.enter("labelMarker"), n.consume(g), n.exit("labelMarker"), n.exit("labelEnd"), c) : t(g);
  }
  function c(g) {
    return g === 40 ? n.attempt(
      Ye,
      m,
      i ? m : o
    )(g) : g === 91 ? n.attempt(
      Xe,
      m,
      i ? s : o
    )(g) : i ? m(g) : o(g);
  }
  function s(g) {
    return n.attempt(
      Je,
      m,
      o
    )(g);
  }
  function m(g) {
    return r(g);
  }
  function o(g) {
    return l._balanced = !0, t(g);
  }
}
function tr(n, r, t) {
  return e;
  function e(o) {
    return n.enter("resource"), n.enter("resourceMarker"), n.consume(o), n.exit("resourceMarker"), u;
  }
  function u(o) {
    return q(o) ? Fn(n, l)(o) : l(o);
  }
  function l(o) {
    return o === 41 ? m(o) : wt(
      n,
      i,
      a,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(o);
  }
  function i(o) {
    return q(o) ? Fn(n, c)(o) : m(o);
  }
  function a(o) {
    return t(o);
  }
  function c(o) {
    return o === 34 || o === 39 || o === 40 ? Ct(
      n,
      s,
      t,
      "resourceTitle",
      "resourceTitleMarker",
      "resourceTitleString"
    )(o) : m(o);
  }
  function s(o) {
    return q(o) ? Fn(n, m)(o) : m(o);
  }
  function m(o) {
    return o === 41 ? (n.enter("resourceMarker"), n.consume(o), n.exit("resourceMarker"), n.exit("resource"), r) : t(o);
  }
}
function er(n, r, t) {
  const e = this;
  return u;
  function u(a) {
    return St.call(
      e,
      n,
      l,
      i,
      "reference",
      "referenceMarker",
      "referenceString"
    )(a);
  }
  function l(a) {
    return e.parser.defined.includes(
      en(
        e.sliceSerialize(e.events[e.events.length - 1][1]).slice(1, -1)
      )
    ) ? r(a) : t(a);
  }
  function i(a) {
    return t(a);
  }
}
function rr(n, r, t) {
  return e;
  function e(l) {
    return n.enter("reference"), n.enter("referenceMarker"), n.consume(l), n.exit("referenceMarker"), u;
  }
  function u(l) {
    return l === 93 ? (n.enter("referenceMarker"), n.consume(l), n.exit("referenceMarker"), n.exit("reference"), r) : t(l);
  }
}
const ir = {
  name: "labelStartImage",
  tokenize: ur,
  resolveAll: Qn.resolveAll
};
function ur(n, r, t) {
  const e = this;
  return u;
  function u(a) {
    return n.enter("labelImage"), n.enter("labelImageMarker"), n.consume(a), n.exit("labelImageMarker"), l;
  }
  function l(a) {
    return a === 91 ? (n.enter("labelMarker"), n.consume(a), n.exit("labelMarker"), n.exit("labelImage"), i) : t(a);
  }
  function i(a) {
    return a === 94 && "_hiddenFootnoteSupport" in e.parser.constructs ? t(a) : r(a);
  }
}
const lr = {
  name: "labelStartLink",
  tokenize: ar,
  resolveAll: Qn.resolveAll
};
function ar(n, r, t) {
  const e = this;
  return u;
  function u(i) {
    return n.enter("labelLink"), n.enter("labelMarker"), n.consume(i), n.exit("labelMarker"), n.exit("labelLink"), l;
  }
  function l(i) {
    return i === 94 && "_hiddenFootnoteSupport" in e.parser.constructs ? t(i) : r(i);
  }
}
const Rn = {
  name: "lineEnding",
  tokenize: or
};
function or(n, r) {
  return t;
  function t(e) {
    return n.enter("lineEnding"), n.consume(e), n.exit("lineEnding"), O(n, r, "linePrefix");
  }
}
const Tn = {
  name: "thematicBreak",
  tokenize: sr
};
function sr(n, r, t) {
  let e = 0, u;
  return l;
  function l(s) {
    return n.enter("thematicBreak"), i(s);
  }
  function i(s) {
    return u = s, a(s);
  }
  function a(s) {
    return s === u ? (n.enter("thematicBreakSequence"), c(s)) : e >= 3 && (s === null || F(s)) ? (n.exit("thematicBreak"), r(s)) : t(s);
  }
  function c(s) {
    return s === u ? (n.consume(s), e++, c) : (n.exit("thematicBreakSequence"), E(s) ? O(n, a, "whitespace")(s) : a(s));
  }
}
const Z = {
  name: "list",
  tokenize: fr,
  continuation: {
    tokenize: pr
  },
  exit: gr
}, cr = {
  tokenize: kr,
  partial: !0
}, hr = {
  tokenize: mr,
  partial: !0
};
function fr(n, r, t) {
  const e = this, u = e.events[e.events.length - 1];
  let l = u && u[1].type === "linePrefix" ? u[2].sliceSerialize(u[1], !0).length : 0, i = 0;
  return a;
  function a(h) {
    const b = e.containerState.type || (h === 42 || h === 43 || h === 45 ? "listUnordered" : "listOrdered");
    if (b === "listUnordered" ? !e.containerState.marker || h === e.containerState.marker : qn(h)) {
      if (e.containerState.type || (e.containerState.type = b, n.enter(b, {
        _container: !0
      })), b === "listUnordered")
        return n.enter("listItemPrefix"), h === 42 || h === 45 ? n.check(Tn, t, s)(h) : s(h);
      if (!e.interrupt || h === 49)
        return n.enter("listItemPrefix"), n.enter("listItemValue"), c(h);
    }
    return t(h);
  }
  function c(h) {
    return qn(h) && ++i < 10 ? (n.consume(h), c) : (!e.interrupt || i < 2) && (e.containerState.marker ? h === e.containerState.marker : h === 41 || h === 46) ? (n.exit("listItemValue"), s(h)) : t(h);
  }
  function s(h) {
    return n.enter("listItemMarker"), n.consume(h), n.exit("listItemMarker"), e.containerState.marker = e.containerState.marker || h, n.check(
      In,
      // Can’t be empty when interrupting.
      e.interrupt ? t : m,
      n.attempt(
        cr,
        g,
        o
      )
    );
  }
  function m(h) {
    return e.containerState.initialBlankLine = !0, l++, g(h);
  }
  function o(h) {
    return E(h) ? (n.enter("listItemPrefixWhitespace"), n.consume(h), n.exit("listItemPrefixWhitespace"), g) : t(h);
  }
  function g(h) {
    return e.containerState.size = l + e.sliceSerialize(n.exit("listItemPrefix"), !0).length, r(h);
  }
}
function pr(n, r, t) {
  const e = this;
  return e.containerState._closeFlow = void 0, n.check(In, u, l);
  function u(a) {
    return e.containerState.furtherBlankLines = e.containerState.furtherBlankLines || e.containerState.initialBlankLine, O(
      n,
      r,
      "listItemIndent",
      e.containerState.size + 1
    )(a);
  }
  function l(a) {
    return e.containerState.furtherBlankLines || !E(a) ? (e.containerState.furtherBlankLines = void 0, e.containerState.initialBlankLine = void 0, i(a)) : (e.containerState.furtherBlankLines = void 0, e.containerState.initialBlankLine = void 0, n.attempt(hr, r, i)(a));
  }
  function i(a) {
    return e.containerState._closeFlow = !0, e.interrupt = void 0, O(
      n,
      n.attempt(Z, r, t),
      "linePrefix",
      e.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(a);
  }
}
function mr(n, r, t) {
  const e = this;
  return O(
    n,
    u,
    "listItemIndent",
    e.containerState.size + 1
  );
  function u(l) {
    const i = e.events[e.events.length - 1];
    return i && i[1].type === "listItemIndent" && i[2].sliceSerialize(i[1], !0).length === e.containerState.size ? r(l) : t(l);
  }
}
function gr(n) {
  n.exit(this.containerState.type);
}
function kr(n, r, t) {
  const e = this;
  return O(
    n,
    u,
    "listItemPrefixWhitespace",
    e.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5
  );
  function u(l) {
    const i = e.events[e.events.length - 1];
    return !E(l) && i && i[1].type === "listItemPrefixWhitespace" ? r(l) : t(l);
  }
}
const lt = {
  name: "setextUnderline",
  tokenize: br,
  resolveTo: xr
};
function xr(n, r) {
  let t = n.length, e, u, l;
  for (; t--; )
    if (n[t][0] === "enter") {
      if (n[t][1].type === "content") {
        e = t;
        break;
      }
      n[t][1].type === "paragraph" && (u = t);
    } else
      n[t][1].type === "content" && n.splice(t, 1), !l && n[t][1].type === "definition" && (l = t);
  const i = {
    type: "setextHeading",
    start: Object.assign({}, n[u][1].start),
    end: Object.assign({}, n[n.length - 1][1].end)
  };
  return n[u][1].type = "setextHeadingText", l ? (n.splice(u, 0, ["enter", i, r]), n.splice(l + 1, 0, ["exit", n[e][1], r]), n[e][1].end = Object.assign({}, n[l][1].end)) : n[e][1] = i, n.push(["exit", i, r]), n;
}
function br(n, r, t) {
  const e = this;
  let u;
  return l;
  function l(s) {
    let m = e.events.length, o;
    for (; m--; )
      if (e.events[m][1].type !== "lineEnding" && e.events[m][1].type !== "linePrefix" && e.events[m][1].type !== "content") {
        o = e.events[m][1].type === "paragraph";
        break;
      }
    return !e.parser.lazy[e.now().line] && (e.interrupt || o) ? (n.enter("setextHeadingLine"), u = s, i(s)) : t(s);
  }
  function i(s) {
    return n.enter("setextHeadingLineSequence"), a(s);
  }
  function a(s) {
    return s === u ? (n.consume(s), a) : (n.exit("setextHeadingLineSequence"), E(s) ? O(n, c, "lineSuffix")(s) : c(s));
  }
  function c(s) {
    return s === null || F(s) ? (n.exit("setextHeadingLine"), r(s)) : t(s);
  }
}
const yr = {
  tokenize: dr
};
function dr(n) {
  const r = this, t = n.attempt(
    // Try to parse a blank line.
    In,
    e,
    // Try to parse initial flow (essentially, only code).
    n.attempt(
      this.parser.constructs.flowInitial,
      u,
      O(
        n,
        n.attempt(
          this.parser.constructs.flow,
          u,
          n.attempt(Fe, u)
        ),
        "linePrefix"
      )
    )
  );
  return t;
  function e(l) {
    if (l === null) {
      n.consume(l);
      return;
    }
    return n.enter("lineEndingBlank"), n.consume(l), n.exit("lineEndingBlank"), r.currentConstruct = void 0, t;
  }
  function u(l) {
    if (l === null) {
      n.consume(l);
      return;
    }
    return n.enter("lineEnding"), n.consume(l), n.exit("lineEnding"), r.currentConstruct = void 0, t;
  }
}
const wr = {
  resolveAll: Ft()
}, Sr = zt("string"), Cr = zt("text");
function zt(n) {
  return {
    tokenize: r,
    resolveAll: Ft(
      n === "text" ? zr : void 0
    )
  };
  function r(t) {
    const e = this, u = this.parser.constructs[n], l = t.attempt(u, i, a);
    return i;
    function i(m) {
      return s(m) ? l(m) : a(m);
    }
    function a(m) {
      if (m === null) {
        t.consume(m);
        return;
      }
      return t.enter("data"), t.consume(m), c;
    }
    function c(m) {
      return s(m) ? (t.exit("data"), l(m)) : (t.consume(m), c);
    }
    function s(m) {
      if (m === null)
        return !0;
      const o = u[m];
      let g = -1;
      if (o)
        for (; ++g < o.length; ) {
          const h = o[g];
          if (!h.previous || h.previous.call(e, e.previous))
            return !0;
        }
      return !1;
    }
  }
}
function Ft(n) {
  return r;
  function r(t, e) {
    let u = -1, l;
    for (; ++u <= t.length; )
      l === void 0 ? t[u] && t[u][1].type === "data" && (l = u, u++) : (!t[u] || t[u][1].type !== "data") && (u !== l + 2 && (t[l][1].end = t[u - 1][1].end, t.splice(l + 2, u - l - 2), u = l + 2), l = void 0);
    return n ? n(t, e) : t;
  }
}
function zr(n, r) {
  let t = 0;
  for (; ++t <= n.length; )
    if ((t === n.length || n[t][1].type === "lineEnding") && n[t - 1][1].type === "data") {
      const e = n[t - 1][1], u = r.sliceStream(e);
      let l = u.length, i = -1, a = 0, c;
      for (; l--; ) {
        const s = u[l];
        if (typeof s == "string") {
          for (i = s.length; s.charCodeAt(i - 1) === 32; )
            a++, i--;
          if (i) break;
          i = -1;
        } else if (s === -2)
          c = !0, a++;
        else if (s !== -1) {
          l++;
          break;
        }
      }
      if (a) {
        const s = {
          type: t === n.length || c || a < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: e.end.line,
            column: e.end.column - a,
            offset: e.end.offset - a,
            _index: e.start._index + l,
            _bufferIndex: l ? i : e.start._bufferIndex + i
          },
          end: Object.assign({}, e.end)
        };
        e.end = Object.assign({}, s.start), e.start.offset === e.end.offset ? Object.assign(e, s) : (n.splice(
          t,
          0,
          ["enter", s, r],
          ["exit", s, r]
        ), t += 2);
      }
      t++;
    }
  return n;
}
function Fr(n, r, t) {
  let e = Object.assign(
    t ? Object.assign({}, t) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const u = {}, l = [];
  let i = [], a = [];
  const c = {
    consume: L,
    enter: S,
    exit: P,
    attempt: _(M),
    check: _(y),
    interrupt: _(y, {
      interrupt: !0
    })
  }, s = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: n,
    sliceStream: h,
    sliceSerialize: g,
    now: b,
    defineSkip: I,
    write: o
  };
  let m = r.tokenize.call(s, c);
  return r.resolveAll && l.push(r), s;
  function o(C) {
    return i = J(i, C), T(), i[i.length - 1] !== null ? [] : (N(r, 0), s.events = Pn(l, s.events, s), s.events);
  }
  function g(C, z) {
    return Ar(h(C), z);
  }
  function h(C) {
    return Ir(i, C);
  }
  function b() {
    const { line: C, column: z, offset: H, _index: V, _bufferIndex: B } = e;
    return {
      line: C,
      column: z,
      offset: H,
      _index: V,
      _bufferIndex: B
    };
  }
  function I(C) {
    u[C.line] = C.column, k();
  }
  function T() {
    let C;
    for (; e._index < i.length; ) {
      const z = i[e._index];
      if (typeof z == "string")
        for (C = e._index, e._bufferIndex < 0 && (e._bufferIndex = 0); e._index === C && e._bufferIndex < z.length; )
          d(z.charCodeAt(e._bufferIndex));
      else
        d(z);
    }
  }
  function d(C) {
    m = m(C);
  }
  function L(C) {
    F(C) ? (e.line++, e.column = 1, e.offset += C === -3 ? 2 : 1, k()) : C !== -1 && (e.column++, e.offset++), e._bufferIndex < 0 ? e._index++ : (e._bufferIndex++, e._bufferIndex === i[e._index].length && (e._bufferIndex = -1, e._index++)), s.previous = C;
  }
  function S(C, z) {
    const H = z || {};
    return H.type = C, H.start = b(), s.events.push(["enter", H, s]), a.push(H), H;
  }
  function P(C) {
    const z = a.pop();
    return z.end = b(), s.events.push(["exit", z, s]), z;
  }
  function M(C, z) {
    N(C, z.from);
  }
  function y(C, z) {
    z.restore();
  }
  function _(C, z) {
    return H;
    function H(V, B, U) {
      let W, K, un, f;
      return Array.isArray(V) ? ln(V) : "tokenize" in V ? (
        // @ts-expect-error Looks like a construct.
        ln([V])
      ) : v(V);
      function v(Q) {
        return Sn;
        function Sn(cn) {
          const bn = cn !== null && Q[cn], mn = cn !== null && Q.null, Bn = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(bn) ? bn : bn ? [bn] : [],
            ...Array.isArray(mn) ? mn : mn ? [mn] : []
          ];
          return ln(Bn)(cn);
        }
      }
      function ln(Q) {
        return W = Q, K = 0, Q.length === 0 ? U : p(Q[K]);
      }
      function p(Q) {
        return Sn;
        function Sn(cn) {
          return f = R(), un = Q, Q.partial || (s.currentConstruct = Q), Q.name && s.parser.constructs.disable.null.includes(Q.name) ? pn() : Q.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            z ? Object.assign(Object.create(s), z) : s,
            c,
            nn,
            pn
          )(cn);
        }
      }
      function nn(Q) {
        return C(un, f), B;
      }
      function pn(Q) {
        return f.restore(), ++K < W.length ? p(W[K]) : U;
      }
    }
  }
  function N(C, z) {
    C.resolveAll && !l.includes(C) && l.push(C), C.resolve && X(
      s.events,
      z,
      s.events.length - z,
      C.resolve(s.events.slice(z), s)
    ), C.resolveTo && (s.events = C.resolveTo(s.events, s));
  }
  function R() {
    const C = b(), z = s.previous, H = s.currentConstruct, V = s.events.length, B = Array.from(a);
    return {
      restore: U,
      from: V
    };
    function U() {
      e = C, s.previous = z, s.currentConstruct = H, s.events.length = V, a = B, k();
    }
  }
  function k() {
    e.line in u && e.column < 2 && (e.column = u[e.line], e.offset += u[e.line] - 1);
  }
}
function Ir(n, r) {
  const t = r.start._index, e = r.start._bufferIndex, u = r.end._index, l = r.end._bufferIndex;
  let i;
  if (t === u)
    i = [n[t].slice(e, l)];
  else {
    if (i = n.slice(t, u), e > -1) {
      const a = i[0];
      typeof a == "string" ? i[0] = a.slice(e) : i.shift();
    }
    l > 0 && i.push(n[u].slice(0, l));
  }
  return i;
}
function Ar(n, r) {
  let t = -1;
  const e = [];
  let u;
  for (; ++t < n.length; ) {
    const l = n[t];
    let i;
    if (typeof l == "string")
      i = l;
    else
      switch (l) {
        case -5: {
          i = "\r";
          break;
        }
        case -4: {
          i = `
`;
          break;
        }
        case -3: {
          i = `\r
`;
          break;
        }
        case -2: {
          i = r ? " " : "	";
          break;
        }
        case -1: {
          if (!r && u) continue;
          i = " ";
          break;
        }
        default:
          i = String.fromCharCode(l);
      }
    u = l === -2, e.push(i);
  }
  return e.join("");
}
const Er = {
  42: Z,
  43: Z,
  45: Z,
  48: Z,
  49: Z,
  50: Z,
  51: Z,
  52: Z,
  53: Z,
  54: Z,
  55: Z,
  56: Z,
  57: Z,
  62: xt
}, Tr = {
  91: Le
}, Lr = {
  [-2]: Mn,
  [-1]: Mn,
  32: Mn
}, Dr = {
  35: Me,
  42: Tn,
  45: [lt, Tn],
  60: qe,
  61: lt,
  95: Tn,
  96: it,
  126: it
}, Or = {
  38: yt,
  92: bt
}, Pr = {
  [-5]: Rn,
  [-4]: Rn,
  [-3]: Rn,
  33: ir,
  38: yt,
  42: Nn,
  60: [ae, Ze],
  91: lr,
  92: [_e, bt],
  93: Qn,
  95: Nn,
  96: de
}, _r = {
  null: [Nn, wr]
}, Br = {
  null: [42, 95]
}, Mr = {
  null: []
}, Rr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: Br,
  contentInitial: Tr,
  disable: Mr,
  document: Er,
  flow: Dr,
  flowInitial: Lr,
  insideSpan: _r,
  string: Or,
  text: Pr
}, Symbol.toStringTag, { value: "Module" }));
function jr(n) {
  const t = (
    /** @type {FullNormalizedExtension} */
    gt([Rr, ...(n || {}).extensions || []])
  ), e = {
    defined: [],
    lazy: {},
    constructs: t,
    content: u(ne),
    document: u(ee),
    flow: u(yr),
    string: u(Sr),
    text: u(Cr)
  };
  return e;
  function u(l) {
    return i;
    function i(a) {
      return Fr(e, l, a);
    }
  }
}
function Hr(n) {
  for (; !dt(n); )
    ;
  return n;
}
const at = /[\0\t\n\r]/g;
function qr() {
  let n = 1, r = "", t = !0, e;
  return u;
  function u(l, i, a) {
    const c = [];
    let s, m, o, g, h;
    for (l = r + (typeof l == "string" ? l.toString() : new TextDecoder(i || void 0).decode(l)), o = 0, r = "", t && (l.charCodeAt(0) === 65279 && o++, t = void 0); o < l.length; ) {
      if (at.lastIndex = o, s = at.exec(l), g = s && s.index !== void 0 ? s.index : l.length, h = l.charCodeAt(g), !s) {
        r = l.slice(o);
        break;
      }
      if (h === 10 && o === g && e)
        c.push(-3), e = void 0;
      else
        switch (e && (c.push(-5), e = void 0), o < g && (c.push(l.slice(o, g)), n += g - o), h) {
          case 0: {
            c.push(65533), n++;
            break;
          }
          case 9: {
            for (m = Math.ceil(n / 4) * 4, c.push(-2); n++ < m; ) c.push(-1);
            break;
          }
          case 10: {
            c.push(-4), n = 1;
            break;
          }
          default:
            e = !0, n = 1;
        }
      o = g + 1;
    }
    return a && (e && c.push(-5), r && c.push(r), c.push(null)), c;
  }
}
const Nr = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function Vr(n) {
  return n.replace(Nr, Wr);
}
function Wr(n, r, t) {
  if (r)
    return r;
  if (t.charCodeAt(0) === 35) {
    const u = t.charCodeAt(1), l = u === 120 || u === 88;
    return kt(t.slice(l ? 2 : 1), l ? 16 : 10);
  }
  return Wn(t) || n;
}
const It = {}.hasOwnProperty;
function Qr(n, r, t) {
  return typeof r != "string" && (t = r, r = void 0), Ur(t)(
    Hr(
      jr(t).document().write(qr()(n, r, !0))
    )
  );
}
function Ur(n) {
  const r = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: l(Xn),
      autolinkProtocol: R,
      autolinkEmail: R,
      atxHeading: l(Zn),
      blockQuote: l(bn),
      characterEscape: R,
      characterReference: R,
      codeFenced: l(mn),
      codeFencedFenceInfo: i,
      codeFencedFenceMeta: i,
      codeIndented: l(mn, i),
      codeText: l(Bn, i),
      codeTextData: R,
      data: R,
      codeFlowValue: R,
      definition: l(jt),
      definitionDestinationString: i,
      definitionLabelString: i,
      definitionTitleString: i,
      emphasis: l(Ht),
      hardBreakEscape: l(Gn),
      hardBreakTrailing: l(Gn),
      htmlFlow: l(Yn, i),
      htmlFlowData: R,
      htmlText: l(Yn, i),
      htmlTextData: R,
      image: l(qt),
      label: i,
      link: l(Xn),
      listItem: l(Nt),
      listItemValue: g,
      listOrdered: l(Jn, o),
      listUnordered: l(Jn),
      paragraph: l(Vt),
      reference: p,
      referenceString: i,
      resourceDestinationString: i,
      resourceTitleString: i,
      setextHeading: l(Zn),
      strong: l(Wt),
      thematicBreak: l(Ut)
    },
    exit: {
      atxHeading: c(),
      atxHeadingSequence: M,
      autolink: c(),
      autolinkEmail: cn,
      autolinkProtocol: Sn,
      blockQuote: c(),
      characterEscapeValue: k,
      characterReferenceMarkerHexadecimal: pn,
      characterReferenceMarkerNumeric: pn,
      characterReferenceValue: Q,
      codeFenced: c(T),
      codeFencedFence: I,
      codeFencedFenceInfo: h,
      codeFencedFenceMeta: b,
      codeFlowValue: k,
      codeIndented: c(d),
      codeText: c(B),
      codeTextData: k,
      data: k,
      definition: c(),
      definitionDestinationString: P,
      definitionLabelString: L,
      definitionTitleString: S,
      emphasis: c(),
      hardBreakEscape: c(z),
      hardBreakTrailing: c(z),
      htmlFlow: c(H),
      htmlFlowData: k,
      htmlText: c(V),
      htmlTextData: k,
      image: c(W),
      label: un,
      labelText: K,
      lineEnding: C,
      link: c(U),
      listItem: c(),
      listOrdered: c(),
      listUnordered: c(),
      paragraph: c(),
      referenceString: nn,
      resourceDestinationString: f,
      resourceTitleString: v,
      resource: ln,
      setextHeading: c(N),
      setextHeadingLineSequence: _,
      setextHeadingText: y,
      strong: c(),
      thematicBreak: c()
    }
  };
  At(r, (n || {}).mdastExtensions || []);
  const t = {};
  return e;
  function e(x) {
    let w = {
      type: "root",
      children: []
    };
    const A = {
      stack: [w],
      tokenStack: [],
      config: r,
      enter: a,
      exit: s,
      buffer: i,
      resume: m,
      data: t
    }, D = [];
    let j = -1;
    for (; ++j < x.length; )
      if (x[j][1].type === "listOrdered" || x[j][1].type === "listUnordered")
        if (x[j][0] === "enter")
          D.push(j);
        else {
          const tn = D.pop();
          j = u(x, tn, j);
        }
    for (j = -1; ++j < x.length; ) {
      const tn = r[x[j][0]];
      It.call(tn, x[j][1].type) && tn[x[j][1].type].call(
        Object.assign(
          {
            sliceSerialize: x[j][2].sliceSerialize
          },
          A
        ),
        x[j][1]
      );
    }
    if (A.tokenStack.length > 0) {
      const tn = A.tokenStack[A.tokenStack.length - 1];
      (tn[1] || ot).call(A, void 0, tn[0]);
    }
    for (w.position = {
      start: hn(
        x.length > 0 ? x[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: hn(
        x.length > 0 ? x[x.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, j = -1; ++j < r.transforms.length; )
      w = r.transforms[j](w) || w;
    return w;
  }
  function u(x, w, A) {
    let D = w - 1, j = -1, tn = !1, gn, an, Cn, zn;
    for (; ++D <= A; ) {
      const Y = x[D];
      switch (Y[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          Y[0] === "enter" ? j++ : j--, zn = void 0;
          break;
        }
        case "lineEndingBlank": {
          Y[0] === "enter" && (gn && !zn && !j && !Cn && (Cn = D), zn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          zn = void 0;
      }
      if (!j && Y[0] === "enter" && Y[1].type === "listItemPrefix" || j === -1 && Y[0] === "exit" && (Y[1].type === "listUnordered" || Y[1].type === "listOrdered")) {
        if (gn) {
          let yn = D;
          for (an = void 0; yn--; ) {
            const on = x[yn];
            if (on[1].type === "lineEnding" || on[1].type === "lineEndingBlank") {
              if (on[0] === "exit") continue;
              an && (x[an][1].type = "lineEndingBlank", tn = !0), on[1].type = "lineEnding", an = yn;
            } else if (!(on[1].type === "linePrefix" || on[1].type === "blockQuotePrefix" || on[1].type === "blockQuotePrefixWhitespace" || on[1].type === "blockQuoteMarker" || on[1].type === "listItemIndent")) break;
          }
          Cn && (!an || Cn < an) && (gn._spread = !0), gn.end = Object.assign(
            {},
            an ? x[an][1].start : Y[1].end
          ), x.splice(an || D, 0, ["exit", gn, Y[2]]), D++, A++;
        }
        if (Y[1].type === "listItemPrefix") {
          const yn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, Y[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          gn = yn, x.splice(D, 0, ["enter", yn, Y[2]]), D++, A++, Cn = void 0, zn = !0;
        }
      }
    }
    return x[w][1]._spread = tn, A;
  }
  function l(x, w) {
    return A;
    function A(D) {
      a.call(this, x(D), D), w && w.call(this, D);
    }
  }
  function i() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function a(x, w, A) {
    this.stack[this.stack.length - 1].children.push(x), this.stack.push(x), this.tokenStack.push([w, A]), x.position = {
      start: hn(w.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function c(x) {
    return w;
    function w(A) {
      x && x.call(this, A), s.call(this, A);
    }
  }
  function s(x, w) {
    const A = this.stack.pop(), D = this.tokenStack.pop();
    if (D)
      D[0].type !== x.type && (w ? w.call(this, x, D[0]) : (D[1] || ot).call(this, x, D[0]));
    else throw new Error(
      "Cannot close `" + x.type + "` (" + En({
        start: x.start,
        end: x.end
      }) + "): it’s not open"
    );
    A.position.end = hn(x.end);
  }
  function m() {
    return Zt(this.stack.pop());
  }
  function o() {
    this.data.expectingFirstListItemValue = !0;
  }
  function g(x) {
    if (this.data.expectingFirstListItemValue) {
      const w = this.stack[this.stack.length - 2];
      w.start = Number.parseInt(this.sliceSerialize(x), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function h() {
    const x = this.resume(), w = this.stack[this.stack.length - 1];
    w.lang = x;
  }
  function b() {
    const x = this.resume(), w = this.stack[this.stack.length - 1];
    w.meta = x;
  }
  function I() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function T() {
    const x = this.resume(), w = this.stack[this.stack.length - 1];
    w.value = x.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function d() {
    const x = this.resume(), w = this.stack[this.stack.length - 1];
    w.value = x.replace(/(\r?\n|\r)$/g, "");
  }
  function L(x) {
    const w = this.resume(), A = this.stack[this.stack.length - 1];
    A.label = w, A.identifier = en(
      this.sliceSerialize(x)
    ).toLowerCase();
  }
  function S() {
    const x = this.resume(), w = this.stack[this.stack.length - 1];
    w.title = x;
  }
  function P() {
    const x = this.resume(), w = this.stack[this.stack.length - 1];
    w.url = x;
  }
  function M(x) {
    const w = this.stack[this.stack.length - 1];
    if (!w.depth) {
      const A = this.sliceSerialize(x).length;
      w.depth = A;
    }
  }
  function y() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function _(x) {
    const w = this.stack[this.stack.length - 1];
    w.depth = this.sliceSerialize(x).codePointAt(0) === 61 ? 1 : 2;
  }
  function N() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function R(x) {
    const A = this.stack[this.stack.length - 1].children;
    let D = A[A.length - 1];
    (!D || D.type !== "text") && (D = Qt(), D.position = {
      start: hn(x.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, A.push(D)), this.stack.push(D);
  }
  function k(x) {
    const w = this.stack.pop();
    w.value += this.sliceSerialize(x), w.position.end = hn(x.end);
  }
  function C(x) {
    const w = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const A = w.children[w.children.length - 1];
      A.position.end = hn(x.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && r.canContainEols.includes(w.type) && (R.call(this, x), k.call(this, x));
  }
  function z() {
    this.data.atHardBreak = !0;
  }
  function H() {
    const x = this.resume(), w = this.stack[this.stack.length - 1];
    w.value = x;
  }
  function V() {
    const x = this.resume(), w = this.stack[this.stack.length - 1];
    w.value = x;
  }
  function B() {
    const x = this.resume(), w = this.stack[this.stack.length - 1];
    w.value = x;
  }
  function U() {
    const x = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const w = this.data.referenceType || "shortcut";
      x.type += "Reference", x.referenceType = w, delete x.url, delete x.title;
    } else
      delete x.identifier, delete x.label;
    this.data.referenceType = void 0;
  }
  function W() {
    const x = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const w = this.data.referenceType || "shortcut";
      x.type += "Reference", x.referenceType = w, delete x.url, delete x.title;
    } else
      delete x.identifier, delete x.label;
    this.data.referenceType = void 0;
  }
  function K(x) {
    const w = this.sliceSerialize(x), A = this.stack[this.stack.length - 2];
    A.label = Vr(w), A.identifier = en(w).toLowerCase();
  }
  function un() {
    const x = this.stack[this.stack.length - 1], w = this.resume(), A = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, A.type === "link") {
      const D = x.children;
      A.children = D;
    } else
      A.alt = w;
  }
  function f() {
    const x = this.resume(), w = this.stack[this.stack.length - 1];
    w.url = x;
  }
  function v() {
    const x = this.resume(), w = this.stack[this.stack.length - 1];
    w.title = x;
  }
  function ln() {
    this.data.inReference = void 0;
  }
  function p() {
    this.data.referenceType = "collapsed";
  }
  function nn(x) {
    const w = this.resume(), A = this.stack[this.stack.length - 1];
    A.label = w, A.identifier = en(
      this.sliceSerialize(x)
    ).toLowerCase(), this.data.referenceType = "full";
  }
  function pn(x) {
    this.data.characterReferenceType = x.type;
  }
  function Q(x) {
    const w = this.sliceSerialize(x), A = this.data.characterReferenceType;
    let D;
    A ? (D = kt(
      w,
      A === "characterReferenceMarkerNumeric" ? 10 : 16
    ), this.data.characterReferenceType = void 0) : D = Wn(w);
    const j = this.stack.pop();
    j.value += D, j.position.end = hn(x.end);
  }
  function Sn(x) {
    k.call(this, x);
    const w = this.stack[this.stack.length - 1];
    w.url = this.sliceSerialize(x);
  }
  function cn(x) {
    k.call(this, x);
    const w = this.stack[this.stack.length - 1];
    w.url = "mailto:" + this.sliceSerialize(x);
  }
  function bn() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function mn() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Bn() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function jt() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Ht() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Zn() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Gn() {
    return {
      type: "break"
    };
  }
  function Yn() {
    return {
      type: "html",
      value: ""
    };
  }
  function qt() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Xn() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Jn(x) {
    return {
      type: "list",
      ordered: x.type === "listOrdered",
      start: null,
      spread: x._spread,
      children: []
    };
  }
  function Nt(x) {
    return {
      type: "listItem",
      spread: x._spread,
      checked: null,
      children: []
    };
  }
  function Vt() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Wt() {
    return {
      type: "strong",
      children: []
    };
  }
  function Qt() {
    return {
      type: "text",
      value: ""
    };
  }
  function Ut() {
    return {
      type: "thematicBreak"
    };
  }
}
function hn(n) {
  return {
    line: n.line,
    column: n.column,
    offset: n.offset
  };
}
function At(n, r) {
  let t = -1;
  for (; ++t < r.length; ) {
    const e = r[t];
    Array.isArray(e) ? At(n, e) : $r(n, e);
  }
}
function $r(n, r) {
  let t;
  for (t in r)
    if (It.call(r, t))
      switch (t) {
        case "canContainEols": {
          const e = r[t];
          e && n[t].push(...e);
          break;
        }
        case "transforms": {
          const e = r[t];
          e && n[t].push(...e);
          break;
        }
        case "enter":
        case "exit": {
          const e = r[t];
          e && Object.assign(n[t], e);
          break;
        }
      }
}
function ot(n, r) {
  throw n ? new Error(
    "Cannot close `" + n.type + "` (" + En({
      start: n.start,
      end: n.end
    }) + "): a different token (`" + r.type + "`, " + En({
      start: r.start,
      end: r.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + r.type + "`, " + En({
      start: r.start,
      end: r.end
    }) + ") is still open"
  );
}
const Zr = {
  tokenize: vr,
  partial: !0
}, Et = {
  tokenize: ni,
  partial: !0
}, Tt = {
  tokenize: ti,
  partial: !0
}, Lt = {
  tokenize: ei,
  partial: !0
}, Gr = {
  tokenize: ri,
  partial: !0
}, Dt = {
  tokenize: Jr,
  previous: Pt
}, Ot = {
  tokenize: Kr,
  previous: _t
}, sn = {
  tokenize: Xr,
  previous: Bt
}, rn = {};
function Yr() {
  return {
    text: rn
  };
}
let kn = 48;
for (; kn < 123; )
  rn[kn] = sn, kn++, kn === 58 ? kn = 65 : kn === 91 && (kn = 97);
rn[43] = sn;
rn[45] = sn;
rn[46] = sn;
rn[95] = sn;
rn[72] = [sn, Ot];
rn[104] = [sn, Ot];
rn[87] = [sn, Dt];
rn[119] = [sn, Dt];
function Xr(n, r, t) {
  const e = this;
  let u, l;
  return i;
  function i(o) {
    return !Vn(o) || !Bt.call(e, e.previous) || Un(e.events) ? t(o) : (n.enter("literalAutolink"), n.enter("literalAutolinkEmail"), a(o));
  }
  function a(o) {
    return Vn(o) ? (n.consume(o), a) : o === 64 ? (n.consume(o), c) : t(o);
  }
  function c(o) {
    return o === 46 ? n.check(
      Gr,
      m,
      s
    )(o) : o === 45 || o === 95 || G(o) ? (l = !0, n.consume(o), c) : m(o);
  }
  function s(o) {
    return n.consume(o), u = !0, c;
  }
  function m(o) {
    return l && u && $(e.previous) ? (n.exit("literalAutolinkEmail"), n.exit("literalAutolink"), r(o)) : t(o);
  }
}
function Jr(n, r, t) {
  const e = this;
  return u;
  function u(i) {
    return i !== 87 && i !== 119 || !Pt.call(e, e.previous) || Un(e.events) ? t(i) : (n.enter("literalAutolink"), n.enter("literalAutolinkWww"), n.check(
      Zr,
      n.attempt(Et, n.attempt(Tt, l), t),
      t
    )(i));
  }
  function l(i) {
    return n.exit("literalAutolinkWww"), n.exit("literalAutolink"), r(i);
  }
}
function Kr(n, r, t) {
  const e = this;
  let u = "", l = !1;
  return i;
  function i(o) {
    return (o === 72 || o === 104) && _t.call(e, e.previous) && !Un(e.events) ? (n.enter("literalAutolink"), n.enter("literalAutolinkHttp"), u += String.fromCodePoint(o), n.consume(o), a) : t(o);
  }
  function a(o) {
    if ($(o) && u.length < 5)
      return u += String.fromCodePoint(o), n.consume(o), a;
    if (o === 58) {
      const g = u.toLowerCase();
      if (g === "http" || g === "https")
        return n.consume(o), c;
    }
    return t(o);
  }
  function c(o) {
    return o === 47 ? (n.consume(o), l ? s : (l = !0, c)) : t(o);
  }
  function s(o) {
    return o === null || Ln(o) || q(o) || xn(o) || On(o) ? t(o) : n.attempt(Et, n.attempt(Tt, m), t)(o);
  }
  function m(o) {
    return n.exit("literalAutolinkHttp"), n.exit("literalAutolink"), r(o);
  }
}
function vr(n, r, t) {
  let e = 0;
  return u;
  function u(i) {
    return (i === 87 || i === 119) && e < 3 ? (e++, n.consume(i), u) : i === 46 && e === 3 ? (n.consume(i), l) : t(i);
  }
  function l(i) {
    return i === null ? t(i) : r(i);
  }
}
function ni(n, r, t) {
  let e, u, l;
  return i;
  function i(s) {
    return s === 46 || s === 95 ? n.check(Lt, c, a)(s) : s === null || q(s) || xn(s) || s !== 45 && On(s) ? c(s) : (l = !0, n.consume(s), i);
  }
  function a(s) {
    return s === 95 ? e = !0 : (u = e, e = void 0), n.consume(s), i;
  }
  function c(s) {
    return u || e || !l ? t(s) : r(s);
  }
}
function ti(n, r) {
  let t = 0, e = 0;
  return u;
  function u(i) {
    return i === 40 ? (t++, n.consume(i), u) : i === 41 && e < t ? l(i) : i === 33 || i === 34 || i === 38 || i === 39 || i === 41 || i === 42 || i === 44 || i === 46 || i === 58 || i === 59 || i === 60 || i === 63 || i === 93 || i === 95 || i === 126 ? n.check(Lt, r, l)(i) : i === null || q(i) || xn(i) ? r(i) : (n.consume(i), u);
  }
  function l(i) {
    return i === 41 && e++, n.consume(i), u;
  }
}
function ei(n, r, t) {
  return e;
  function e(a) {
    return a === 33 || a === 34 || a === 39 || a === 41 || a === 42 || a === 44 || a === 46 || a === 58 || a === 59 || a === 63 || a === 95 || a === 126 ? (n.consume(a), e) : a === 38 ? (n.consume(a), l) : a === 93 ? (n.consume(a), u) : (
      // `<` is an end.
      a === 60 || // So is whitespace.
      a === null || q(a) || xn(a) ? r(a) : t(a)
    );
  }
  function u(a) {
    return a === null || a === 40 || a === 91 || q(a) || xn(a) ? r(a) : e(a);
  }
  function l(a) {
    return $(a) ? i(a) : t(a);
  }
  function i(a) {
    return a === 59 ? (n.consume(a), e) : $(a) ? (n.consume(a), i) : t(a);
  }
}
function ri(n, r, t) {
  return e;
  function e(l) {
    return n.consume(l), u;
  }
  function u(l) {
    return G(l) ? t(l) : r(l);
  }
}
function Pt(n) {
  return n === null || n === 40 || n === 42 || n === 95 || n === 91 || n === 93 || n === 126 || q(n);
}
function _t(n) {
  return !$(n);
}
function Bt(n) {
  return !(n === 47 || Vn(n));
}
function Vn(n) {
  return n === 43 || n === 45 || n === 46 || n === 95 || G(n);
}
function Un(n) {
  let r = n.length, t = !1;
  for (; r--; ) {
    const e = n[r][1];
    if ((e.type === "labelLink" || e.type === "labelImage") && !e._balanced) {
      t = !0;
      break;
    }
    if (e._gfmAutolinkLiteralWalkedInto) {
      t = !1;
      break;
    }
  }
  return n.length > 0 && !t && (n[n.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), t;
}
const ii = {
  tokenize: fi,
  partial: !0
};
function ui() {
  return {
    document: {
      91: {
        tokenize: si,
        continuation: {
          tokenize: ci
        },
        exit: hi
      }
    },
    text: {
      91: {
        tokenize: oi
      },
      93: {
        add: "after",
        tokenize: li,
        resolveTo: ai
      }
    }
  };
}
function li(n, r, t) {
  const e = this;
  let u = e.events.length;
  const l = e.parser.gfmFootnotes || (e.parser.gfmFootnotes = []);
  let i;
  for (; u--; ) {
    const c = e.events[u][1];
    if (c.type === "labelImage") {
      i = c;
      break;
    }
    if (c.type === "gfmFootnoteCall" || c.type === "labelLink" || c.type === "label" || c.type === "image" || c.type === "link")
      break;
  }
  return a;
  function a(c) {
    if (!i || !i._balanced)
      return t(c);
    const s = en(
      e.sliceSerialize({
        start: i.end,
        end: e.now()
      })
    );
    return s.codePointAt(0) !== 94 || !l.includes(s.slice(1)) ? t(c) : (n.enter("gfmFootnoteCallLabelMarker"), n.consume(c), n.exit("gfmFootnoteCallLabelMarker"), r(c));
  }
}
function ai(n, r) {
  let t = n.length;
  for (; t--; )
    if (n[t][1].type === "labelImage" && n[t][0] === "enter") {
      n[t][1];
      break;
    }
  n[t + 1][1].type = "data", n[t + 3][1].type = "gfmFootnoteCallLabelMarker";
  const e = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, n[t + 3][1].start),
    end: Object.assign({}, n[n.length - 1][1].end)
  }, u = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, n[t + 3][1].end),
    end: Object.assign({}, n[t + 3][1].end)
  };
  u.end.column++, u.end.offset++, u.end._bufferIndex++;
  const l = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, u.end),
    end: Object.assign({}, n[n.length - 1][1].start)
  }, i = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, l.start),
    end: Object.assign({}, l.end)
  }, a = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    n[t + 1],
    n[t + 2],
    ["enter", e, r],
    // The `[`
    n[t + 3],
    n[t + 4],
    // The `^`.
    ["enter", u, r],
    ["exit", u, r],
    // Everything in between.
    ["enter", l, r],
    ["enter", i, r],
    ["exit", i, r],
    ["exit", l, r],
    // The ending (`]`, properly parsed and labelled).
    n[n.length - 2],
    n[n.length - 1],
    ["exit", e, r]
  ];
  return n.splice(t, n.length - t + 1, ...a), n;
}
function oi(n, r, t) {
  const e = this, u = e.parser.gfmFootnotes || (e.parser.gfmFootnotes = []);
  let l = 0, i;
  return a;
  function a(o) {
    return n.enter("gfmFootnoteCall"), n.enter("gfmFootnoteCallLabelMarker"), n.consume(o), n.exit("gfmFootnoteCallLabelMarker"), c;
  }
  function c(o) {
    return o !== 94 ? t(o) : (n.enter("gfmFootnoteCallMarker"), n.consume(o), n.exit("gfmFootnoteCallMarker"), n.enter("gfmFootnoteCallString"), n.enter("chunkString").contentType = "string", s);
  }
  function s(o) {
    if (
      // Too long.
      l > 999 || // Closing brace with nothing.
      o === 93 && !i || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      o === null || o === 91 || q(o)
    )
      return t(o);
    if (o === 93) {
      n.exit("chunkString");
      const g = n.exit("gfmFootnoteCallString");
      return u.includes(en(e.sliceSerialize(g))) ? (n.enter("gfmFootnoteCallLabelMarker"), n.consume(o), n.exit("gfmFootnoteCallLabelMarker"), n.exit("gfmFootnoteCall"), r) : t(o);
    }
    return q(o) || (i = !0), l++, n.consume(o), o === 92 ? m : s;
  }
  function m(o) {
    return o === 91 || o === 92 || o === 93 ? (n.consume(o), l++, s) : s(o);
  }
}
function si(n, r, t) {
  const e = this, u = e.parser.gfmFootnotes || (e.parser.gfmFootnotes = []);
  let l, i = 0, a;
  return c;
  function c(b) {
    return n.enter("gfmFootnoteDefinition")._container = !0, n.enter("gfmFootnoteDefinitionLabel"), n.enter("gfmFootnoteDefinitionLabelMarker"), n.consume(b), n.exit("gfmFootnoteDefinitionLabelMarker"), s;
  }
  function s(b) {
    return b === 94 ? (n.enter("gfmFootnoteDefinitionMarker"), n.consume(b), n.exit("gfmFootnoteDefinitionMarker"), n.enter("gfmFootnoteDefinitionLabelString"), n.enter("chunkString").contentType = "string", m) : t(b);
  }
  function m(b) {
    if (
      // Too long.
      i > 999 || // Closing brace with nothing.
      b === 93 && !a || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      b === null || b === 91 || q(b)
    )
      return t(b);
    if (b === 93) {
      n.exit("chunkString");
      const I = n.exit("gfmFootnoteDefinitionLabelString");
      return l = en(e.sliceSerialize(I)), n.enter("gfmFootnoteDefinitionLabelMarker"), n.consume(b), n.exit("gfmFootnoteDefinitionLabelMarker"), n.exit("gfmFootnoteDefinitionLabel"), g;
    }
    return q(b) || (a = !0), i++, n.consume(b), b === 92 ? o : m;
  }
  function o(b) {
    return b === 91 || b === 92 || b === 93 ? (n.consume(b), i++, m) : m(b);
  }
  function g(b) {
    return b === 58 ? (n.enter("definitionMarker"), n.consume(b), n.exit("definitionMarker"), u.includes(l) || u.push(l), O(
      n,
      h,
      "gfmFootnoteDefinitionWhitespace"
    )) : t(b);
  }
  function h(b) {
    return r(b);
  }
}
function ci(n, r, t) {
  return n.check(In, r, n.attempt(ii, r, t));
}
function hi(n) {
  n.exit("gfmFootnoteDefinition");
}
function fi(n, r, t) {
  const e = this;
  return O(
    n,
    u,
    "gfmFootnoteDefinitionIndent",
    5
  );
  function u(l) {
    const i = e.events[e.events.length - 1];
    return i && i[1].type === "gfmFootnoteDefinitionIndent" && i[2].sliceSerialize(i[1], !0).length === 4 ? r(l) : t(l);
  }
}
function pi(n) {
  let t = {}.singleTilde;
  const e = {
    tokenize: l,
    resolveAll: u
  };
  return t == null && (t = !0), {
    text: {
      126: e
    },
    insideSpan: {
      null: [e]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function u(i, a) {
    let c = -1;
    for (; ++c < i.length; )
      if (i[c][0] === "enter" && i[c][1].type === "strikethroughSequenceTemporary" && i[c][1]._close) {
        let s = c;
        for (; s--; )
          if (i[s][0] === "exit" && i[s][1].type === "strikethroughSequenceTemporary" && i[s][1]._open && // If the sizes are the same:
          i[c][1].end.offset - i[c][1].start.offset === i[s][1].end.offset - i[s][1].start.offset) {
            i[c][1].type = "strikethroughSequence", i[s][1].type = "strikethroughSequence";
            const m = {
              type: "strikethrough",
              start: Object.assign({}, i[s][1].start),
              end: Object.assign({}, i[c][1].end)
            }, o = {
              type: "strikethroughText",
              start: Object.assign({}, i[s][1].end),
              end: Object.assign({}, i[c][1].start)
            }, g = [
              ["enter", m, a],
              ["enter", i[s][1], a],
              ["exit", i[s][1], a],
              ["enter", o, a]
            ], h = a.parser.constructs.insideSpan.null;
            h && X(
              g,
              g.length,
              0,
              Pn(h, i.slice(s + 1, c), a)
            ), X(g, g.length, 0, [
              ["exit", o, a],
              ["enter", i[c][1], a],
              ["exit", i[c][1], a],
              ["exit", m, a]
            ]), X(i, s - 1, c - s + 3, g), c = s + g.length - 2;
            break;
          }
      }
    for (c = -1; ++c < i.length; )
      i[c][1].type === "strikethroughSequenceTemporary" && (i[c][1].type = "data");
    return i;
  }
  function l(i, a, c) {
    const s = this.previous, m = this.events;
    let o = 0;
    return g;
    function g(b) {
      return s === 126 && m[m.length - 1][1].type !== "characterEscape" ? c(b) : (i.enter("strikethroughSequenceTemporary"), h(b));
    }
    function h(b) {
      const I = Dn(s);
      if (b === 126)
        return o > 1 ? c(b) : (i.consume(b), o++, h);
      if (o < 2 && !t) return c(b);
      const T = i.exit("strikethroughSequenceTemporary"), d = Dn(b);
      return T._open = !d || d === 2 && !!I, T._close = !I || I === 2 && !!d, a(b);
    }
  }
}
class mi {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(r, t, e) {
    gi(this, r, t, e);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImpl(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(r) {
    if (this.map.sort(function(l, i) {
      return l[0] - i[0];
    }), this.map.length === 0)
      return;
    let t = this.map.length;
    const e = [];
    for (; t > 0; )
      t -= 1, e.push(
        r.slice(this.map[t][0] + this.map[t][1]),
        this.map[t][2]
      ), r.length = this.map[t][0];
    e.push([...r]), r.length = 0;
    let u = e.pop();
    for (; u; )
      r.push(...u), u = e.pop();
    this.map.length = 0;
  }
}
function gi(n, r, t, e) {
  let u = 0;
  if (!(t === 0 && e.length === 0)) {
    for (; u < n.map.length; ) {
      if (n.map[u][0] === r) {
        n.map[u][1] += t, n.map[u][2].push(...e);
        return;
      }
      u += 1;
    }
    n.map.push([r, t, e]);
  }
}
function ki(n, r) {
  let t = !1;
  const e = [];
  for (; r < n.length; ) {
    const u = n[r];
    if (t) {
      if (u[0] === "enter")
        u[1].type === "tableContent" && e.push(
          n[r + 1][1].type === "tableDelimiterMarker" ? "left" : "none"
        );
      else if (u[1].type === "tableContent") {
        if (n[r - 1][1].type === "tableDelimiterMarker") {
          const l = e.length - 1;
          e[l] = e[l] === "left" ? "center" : "right";
        }
      } else if (u[1].type === "tableDelimiterRow")
        break;
    } else u[0] === "enter" && u[1].type === "tableDelimiterRow" && (t = !0);
    r += 1;
  }
  return e;
}
function xi() {
  return {
    flow: {
      null: {
        tokenize: bi,
        resolveAll: yi
      }
    }
  };
}
function bi(n, r, t) {
  const e = this;
  let u = 0, l = 0, i;
  return a;
  function a(k) {
    let C = e.events.length - 1;
    for (; C > -1; ) {
      const V = e.events[C][1].type;
      if (V === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      V === "linePrefix")
        C--;
      else break;
    }
    const z = C > -1 ? e.events[C][1].type : null, H = z === "tableHead" || z === "tableRow" ? y : c;
    return H === y && e.parser.lazy[e.now().line] ? t(k) : H(k);
  }
  function c(k) {
    return n.enter("tableHead"), n.enter("tableRow"), s(k);
  }
  function s(k) {
    return k === 124 || (i = !0, l += 1), m(k);
  }
  function m(k) {
    return k === null ? t(k) : F(k) ? l > 1 ? (l = 0, e.interrupt = !0, n.exit("tableRow"), n.enter("lineEnding"), n.consume(k), n.exit("lineEnding"), h) : t(k) : E(k) ? O(n, m, "whitespace")(k) : (l += 1, i && (i = !1, u += 1), k === 124 ? (n.enter("tableCellDivider"), n.consume(k), n.exit("tableCellDivider"), i = !0, m) : (n.enter("data"), o(k)));
  }
  function o(k) {
    return k === null || k === 124 || q(k) ? (n.exit("data"), m(k)) : (n.consume(k), k === 92 ? g : o);
  }
  function g(k) {
    return k === 92 || k === 124 ? (n.consume(k), o) : o(k);
  }
  function h(k) {
    return e.interrupt = !1, e.parser.lazy[e.now().line] ? t(k) : (n.enter("tableDelimiterRow"), i = !1, E(k) ? O(
      n,
      b,
      "linePrefix",
      e.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(k) : b(k));
  }
  function b(k) {
    return k === 45 || k === 58 ? T(k) : k === 124 ? (i = !0, n.enter("tableCellDivider"), n.consume(k), n.exit("tableCellDivider"), I) : M(k);
  }
  function I(k) {
    return E(k) ? O(n, T, "whitespace")(k) : T(k);
  }
  function T(k) {
    return k === 58 ? (l += 1, i = !0, n.enter("tableDelimiterMarker"), n.consume(k), n.exit("tableDelimiterMarker"), d) : k === 45 ? (l += 1, d(k)) : k === null || F(k) ? P(k) : M(k);
  }
  function d(k) {
    return k === 45 ? (n.enter("tableDelimiterFiller"), L(k)) : M(k);
  }
  function L(k) {
    return k === 45 ? (n.consume(k), L) : k === 58 ? (i = !0, n.exit("tableDelimiterFiller"), n.enter("tableDelimiterMarker"), n.consume(k), n.exit("tableDelimiterMarker"), S) : (n.exit("tableDelimiterFiller"), S(k));
  }
  function S(k) {
    return E(k) ? O(n, P, "whitespace")(k) : P(k);
  }
  function P(k) {
    return k === 124 ? b(k) : k === null || F(k) ? !i || u !== l ? M(k) : (n.exit("tableDelimiterRow"), n.exit("tableHead"), r(k)) : M(k);
  }
  function M(k) {
    return t(k);
  }
  function y(k) {
    return n.enter("tableRow"), _(k);
  }
  function _(k) {
    return k === 124 ? (n.enter("tableCellDivider"), n.consume(k), n.exit("tableCellDivider"), _) : k === null || F(k) ? (n.exit("tableRow"), r(k)) : E(k) ? O(n, _, "whitespace")(k) : (n.enter("data"), N(k));
  }
  function N(k) {
    return k === null || k === 124 || q(k) ? (n.exit("data"), _(k)) : (n.consume(k), k === 92 ? R : N);
  }
  function R(k) {
    return k === 92 || k === 124 ? (n.consume(k), N) : N(k);
  }
}
function yi(n, r) {
  let t = -1, e = !0, u = 0, l = [0, 0, 0, 0], i = [0, 0, 0, 0], a = !1, c = 0, s, m, o;
  const g = new mi();
  for (; ++t < n.length; ) {
    const h = n[t], b = h[1];
    h[0] === "enter" ? b.type === "tableHead" ? (a = !1, c !== 0 && (st(g, r, c, s, m), m = void 0, c = 0), s = {
      type: "table",
      start: Object.assign({}, b.start),
      // Note: correct end is set later.
      end: Object.assign({}, b.end)
    }, g.add(t, 0, [["enter", s, r]])) : b.type === "tableRow" || b.type === "tableDelimiterRow" ? (e = !0, o = void 0, l = [0, 0, 0, 0], i = [0, t + 1, 0, 0], a && (a = !1, m = {
      type: "tableBody",
      start: Object.assign({}, b.start),
      // Note: correct end is set later.
      end: Object.assign({}, b.end)
    }, g.add(t, 0, [["enter", m, r]])), u = b.type === "tableDelimiterRow" ? 2 : m ? 3 : 1) : u && (b.type === "data" || b.type === "tableDelimiterMarker" || b.type === "tableDelimiterFiller") ? (e = !1, i[2] === 0 && (l[1] !== 0 && (i[0] = i[1], o = An(
      g,
      r,
      l,
      u,
      void 0,
      o
    ), l = [0, 0, 0, 0]), i[2] = t)) : b.type === "tableCellDivider" && (e ? e = !1 : (l[1] !== 0 && (i[0] = i[1], o = An(
      g,
      r,
      l,
      u,
      void 0,
      o
    )), l = i, i = [l[1], t, 0, 0])) : b.type === "tableHead" ? (a = !0, c = t) : b.type === "tableRow" || b.type === "tableDelimiterRow" ? (c = t, l[1] !== 0 ? (i[0] = i[1], o = An(
      g,
      r,
      l,
      u,
      t,
      o
    )) : i[1] !== 0 && (o = An(g, r, i, u, t, o)), u = 0) : u && (b.type === "data" || b.type === "tableDelimiterMarker" || b.type === "tableDelimiterFiller") && (i[3] = t);
  }
  for (c !== 0 && st(g, r, c, s, m), g.consume(r.events), t = -1; ++t < r.events.length; ) {
    const h = r.events[t];
    h[0] === "enter" && h[1].type === "table" && (h[1]._align = ki(r.events, t));
  }
  return n;
}
function An(n, r, t, e, u, l) {
  const i = e === 1 ? "tableHeader" : e === 2 ? "tableDelimiter" : "tableData", a = "tableContent";
  t[0] !== 0 && (l.end = Object.assign({}, dn(r.events, t[0])), n.add(t[0], 0, [["exit", l, r]]));
  const c = dn(r.events, t[1]);
  if (l = {
    type: i,
    start: Object.assign({}, c),
    // Note: correct end is set later.
    end: Object.assign({}, c)
  }, n.add(t[1], 0, [["enter", l, r]]), t[2] !== 0) {
    const s = dn(r.events, t[2]), m = dn(r.events, t[3]), o = {
      type: a,
      start: Object.assign({}, s),
      end: Object.assign({}, m)
    };
    if (n.add(t[2], 0, [["enter", o, r]]), e !== 2) {
      const g = r.events[t[2]], h = r.events[t[3]];
      if (g[1].end = Object.assign({}, h[1].end), g[1].type = "chunkText", g[1].contentType = "text", t[3] > t[2] + 1) {
        const b = t[2] + 1, I = t[3] - t[2] - 1;
        n.add(b, I, []);
      }
    }
    n.add(t[3] + 1, 0, [["exit", o, r]]);
  }
  return u !== void 0 && (l.end = Object.assign({}, dn(r.events, u)), n.add(u, 0, [["exit", l, r]]), l = void 0), l;
}
function st(n, r, t, e, u) {
  const l = [], i = dn(r.events, t);
  u && (u.end = Object.assign({}, i), l.push(["exit", u, r])), e.end = Object.assign({}, i), l.push(["exit", e, r]), n.add(t + 1, 0, l);
}
function dn(n, r) {
  const t = n[r], e = t[0] === "enter" ? "start" : "end";
  return t[1][e];
}
const di = {
  tokenize: Si
};
function wi() {
  return {
    text: {
      91: di
    }
  };
}
function Si(n, r, t) {
  const e = this;
  return u;
  function u(c) {
    return (
      // Exit if there’s stuff before.
      e.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !e._gfmTasklistFirstContentOfListItem ? t(c) : (n.enter("taskListCheck"), n.enter("taskListCheckMarker"), n.consume(c), n.exit("taskListCheckMarker"), l)
    );
  }
  function l(c) {
    return q(c) ? (n.enter("taskListCheckValueUnchecked"), n.consume(c), n.exit("taskListCheckValueUnchecked"), i) : c === 88 || c === 120 ? (n.enter("taskListCheckValueChecked"), n.consume(c), n.exit("taskListCheckValueChecked"), i) : t(c);
  }
  function i(c) {
    return c === 93 ? (n.enter("taskListCheckMarker"), n.consume(c), n.exit("taskListCheckMarker"), n.exit("taskListCheck"), a) : t(c);
  }
  function a(c) {
    return F(c) ? r(c) : E(c) ? n.check(
      {
        tokenize: Ci
      },
      r,
      t
    )(c) : t(c);
  }
}
function Ci(n, r, t) {
  return O(n, e, "whitespace");
  function e(u) {
    return u === null ? t(u) : r(u);
  }
}
function zi(n) {
  return gt([
    Yr(),
    ui(),
    pi(),
    xi(),
    wi()
  ]);
}
function ct(n, r) {
  const t = String(n);
  if (typeof r != "string")
    throw new TypeError("Expected character");
  let e = 0, u = t.indexOf(r);
  for (; u !== -1; )
    e++, u = t.indexOf(r, u + r.length);
  return e;
}
function Fi(n) {
  if (typeof n != "string")
    throw new TypeError("Expected a string");
  return n.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const $n = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(n) {
    if (n == null)
      return Ti;
    if (typeof n == "function")
      return _n(n);
    if (typeof n == "object")
      return Array.isArray(n) ? Ii(n) : Ai(n);
    if (typeof n == "string")
      return Ei(n);
    throw new Error("Expected function, string, or object as test");
  }
);
function Ii(n) {
  const r = [];
  let t = -1;
  for (; ++t < n.length; )
    r[t] = $n(n[t]);
  return _n(e);
  function e(...u) {
    let l = -1;
    for (; ++l < r.length; )
      if (r[l].apply(this, u)) return !0;
    return !1;
  }
}
function Ai(n) {
  const r = (
    /** @type {Record<string, unknown>} */
    n
  );
  return _n(t);
  function t(e) {
    const u = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      e
    );
    let l;
    for (l in n)
      if (u[l] !== r[l]) return !1;
    return !0;
  }
}
function Ei(n) {
  return _n(r);
  function r(t) {
    return t && t.type === n;
  }
}
function _n(n) {
  return r;
  function r(t, e, u) {
    return !!(Li(t) && n.call(
      this,
      t,
      typeof e == "number" ? e : void 0,
      u || void 0
    ));
  }
}
function Ti() {
  return !0;
}
function Li(n) {
  return n !== null && typeof n == "object" && "type" in n;
}
const Mt = [], Di = !0, ht = !1, Oi = "skip";
function Pi(n, r, t, e) {
  let u;
  u = r;
  const l = $n(u), i = 1;
  a(n, void 0, [])();
  function a(c, s, m) {
    const o = (
      /** @type {Record<string, unknown>} */
      c && typeof c == "object" ? c : {}
    );
    if (typeof o.type == "string") {
      const h = (
        // `hast`
        typeof o.tagName == "string" ? o.tagName : (
          // `xast`
          typeof o.name == "string" ? o.name : void 0
        )
      );
      Object.defineProperty(g, "name", {
        value: "node (" + (c.type + (h ? "<" + h + ">" : "")) + ")"
      });
    }
    return g;
    function g() {
      let h = Mt, b, I, T;
      if (l(c, s, m[m.length - 1] || void 0) && (h = _i(t(c, m)), h[0] === ht))
        return h;
      if ("children" in c && c.children) {
        const d = (
          /** @type {UnistParent} */
          c
        );
        if (d.children && h[0] !== Oi)
          for (I = -1 + i, T = m.concat(d); I > -1 && I < d.children.length; ) {
            const L = d.children[I];
            if (b = a(L, I, T)(), b[0] === ht)
              return b;
            I = typeof b[1] == "number" ? b[1] : I + i;
          }
      }
      return h;
    }
  }
}
function _i(n) {
  return Array.isArray(n) ? n : typeof n == "number" ? [Di, n] : n == null ? Mt : [n];
}
function Bi(n, r, t) {
  const u = $n((t || {}).ignore || []), l = Mi(r);
  let i = -1;
  for (; ++i < l.length; )
    Pi(n, "text", a);
  function a(s, m) {
    let o = -1, g;
    for (; ++o < m.length; ) {
      const h = m[o], b = g ? g.children : void 0;
      if (u(
        h,
        b ? b.indexOf(h) : void 0,
        g
      ))
        return;
      g = h;
    }
    if (g)
      return c(s, m);
  }
  function c(s, m) {
    const o = m[m.length - 1], g = l[i][0], h = l[i][1];
    let b = 0;
    const T = o.children.indexOf(s);
    let d = !1, L = [];
    g.lastIndex = 0;
    let S = g.exec(s.value);
    for (; S; ) {
      const P = S.index, M = {
        index: S.index,
        input: S.input,
        stack: [...m, s]
      };
      let y = h(...S, M);
      if (typeof y == "string" && (y = y.length > 0 ? { type: "text", value: y } : void 0), y === !1 ? g.lastIndex = P + 1 : (b !== P && L.push({
        type: "text",
        value: s.value.slice(b, P)
      }), Array.isArray(y) ? L.push(...y) : y && L.push(y), b = P + S[0].length, d = !0), !g.global)
        break;
      S = g.exec(s.value);
    }
    return d ? (b < s.value.length && L.push({ type: "text", value: s.value.slice(b) }), o.children.splice(T, 1, ...L)) : L = [s], T + L.length;
  }
}
function Mi(n) {
  const r = [];
  if (!Array.isArray(n))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const t = !n[0] || Array.isArray(n[0]) ? n : [n];
  let e = -1;
  for (; ++e < t.length; ) {
    const u = t[e];
    r.push([Ri(u[0]), ji(u[1])]);
  }
  return r;
}
function Ri(n) {
  return typeof n == "string" ? new RegExp(Fi(n), "g") : n;
}
function ji(n) {
  return typeof n == "function" ? n : function() {
    return n;
  };
}
function Hi() {
  return {
    transforms: [Ui],
    enter: {
      literalAutolink: qi,
      literalAutolinkEmail: jn,
      literalAutolinkHttp: jn,
      literalAutolinkWww: jn
    },
    exit: {
      literalAutolink: Qi,
      literalAutolinkEmail: Wi,
      literalAutolinkHttp: Ni,
      literalAutolinkWww: Vi
    }
  };
}
function qi(n) {
  this.enter({ type: "link", title: null, url: "", children: [] }, n);
}
function jn(n) {
  this.config.enter.autolinkProtocol.call(this, n);
}
function Ni(n) {
  this.config.exit.autolinkProtocol.call(this, n);
}
function Vi(n) {
  this.config.exit.data.call(this, n);
  const r = this.stack[this.stack.length - 1];
  wn(r.type === "link"), r.url = "http://" + this.sliceSerialize(n);
}
function Wi(n) {
  this.config.exit.autolinkEmail.call(this, n);
}
function Qi(n) {
  this.exit(n);
}
function Ui(n) {
  Bi(
    n,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, $i],
      [/([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g, Zi]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function $i(n, r, t, e, u) {
  let l = "";
  if (!Rt(u) || (/^w/i.test(r) && (t = r + t, r = "", l = "http://"), !Gi(t)))
    return !1;
  const i = Yi(t + e);
  if (!i[0]) return !1;
  const a = {
    type: "link",
    title: null,
    url: l + r + i[0],
    children: [{ type: "text", value: r + i[0] }]
  };
  return i[1] ? [a, { type: "text", value: i[1] }] : a;
}
function Zi(n, r, t, e) {
  return (
    // Not an expected previous character.
    !Rt(e, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(t) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + r + "@" + t,
      children: [{ type: "text", value: r + "@" + t }]
    }
  );
}
function Gi(n) {
  const r = n.split(".");
  return !(r.length < 2 || r[r.length - 1] && (/_/.test(r[r.length - 1]) || !/[a-zA-Z\d]/.test(r[r.length - 1])) || r[r.length - 2] && (/_/.test(r[r.length - 2]) || !/[a-zA-Z\d]/.test(r[r.length - 2])));
}
function Yi(n) {
  const r = /[!"&'),.:;<>?\]}]+$/.exec(n);
  if (!r)
    return [n, void 0];
  n = n.slice(0, r.index);
  let t = r[0], e = t.indexOf(")");
  const u = ct(n, "(");
  let l = ct(n, ")");
  for (; e !== -1 && u > l; )
    n += t.slice(0, e + 1), t = t.slice(e + 1), e = t.indexOf(")"), l++;
  return [n, t];
}
function Rt(n, r) {
  const t = n.input.charCodeAt(n.index - 1);
  return (n.index === 0 || xn(t) || On(t)) && (!r || t !== 47);
}
function Xi() {
  return {
    enter: {
      gfmFootnoteDefinition: Ji,
      gfmFootnoteDefinitionLabelString: Ki,
      gfmFootnoteCall: tu,
      gfmFootnoteCallString: eu
    },
    exit: {
      gfmFootnoteDefinition: nu,
      gfmFootnoteDefinitionLabelString: vi,
      gfmFootnoteCall: iu,
      gfmFootnoteCallString: ru
    }
  };
}
function Ji(n) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    n
  );
}
function Ki() {
  this.buffer();
}
function vi(n) {
  const r = this.resume(), t = this.stack[this.stack.length - 1];
  wn(t.type === "footnoteDefinition"), t.label = r, t.identifier = en(
    this.sliceSerialize(n)
  ).toLowerCase();
}
function nu(n) {
  this.exit(n);
}
function tu(n) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, n);
}
function eu() {
  this.buffer();
}
function ru(n) {
  const r = this.resume(), t = this.stack[this.stack.length - 1];
  wn(t.type === "footnoteReference"), t.label = r, t.identifier = en(
    this.sliceSerialize(n)
  ).toLowerCase();
}
function iu(n) {
  this.exit(n);
}
function uu() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: lu },
    exit: { strikethrough: au }
  };
}
function lu(n) {
  this.enter({ type: "delete", children: [] }, n);
}
function au(n) {
  this.exit(n);
}
function ou() {
  return {
    enter: {
      table: su,
      tableData: ft,
      tableHeader: ft,
      tableRow: hu
    },
    exit: {
      codeText: fu,
      table: cu,
      tableData: Hn,
      tableHeader: Hn,
      tableRow: Hn
    }
  };
}
function su(n) {
  const r = n._align;
  this.enter(
    {
      type: "table",
      align: r.map(function(t) {
        return t === "none" ? null : t;
      }),
      children: []
    },
    n
  ), this.data.inTable = !0;
}
function cu(n) {
  this.exit(n), this.data.inTable = void 0;
}
function hu(n) {
  this.enter({ type: "tableRow", children: [] }, n);
}
function Hn(n) {
  this.exit(n);
}
function ft(n) {
  this.enter({ type: "tableCell", children: [] }, n);
}
function fu(n) {
  let r = this.resume();
  this.data.inTable && (r = r.replace(/\\([\\|])/g, pu));
  const t = this.stack[this.stack.length - 1];
  wn(t.type === "inlineCode"), t.value = r, this.exit(n);
}
function pu(n, r) {
  return r === "|" ? r : n;
}
function mu() {
  return {
    exit: {
      taskListCheckValueChecked: pt,
      taskListCheckValueUnchecked: pt,
      paragraph: gu
    }
  };
}
function pt(n) {
  const r = this.stack[this.stack.length - 2];
  wn(r.type === "listItem"), r.checked = n.type === "taskListCheckValueChecked";
}
function gu(n) {
  const r = this.stack[this.stack.length - 2];
  if (r && r.type === "listItem" && typeof r.checked == "boolean") {
    const t = this.stack[this.stack.length - 1];
    wn(t.type === "paragraph");
    const e = t.children[0];
    if (e && e.type === "text") {
      const u = r.children;
      let l = -1, i;
      for (; ++l < u.length; ) {
        const a = u[l];
        if (a.type === "paragraph") {
          i = a;
          break;
        }
      }
      i === t && (e.value = e.value.slice(1), e.value.length === 0 ? t.children.shift() : t.position && e.position && typeof e.position.start.offset == "number" && (e.position.start.column++, e.position.start.offset++, t.position.start = Object.assign({}, e.position.start)));
    }
  }
  this.exit(n);
}
function ku() {
  return [
    Hi(),
    Xi(),
    uu(),
    ou(),
    mu()
  ];
}
const bu = (n, r, t) => Qr(n, {
  extensions: [zi(), ...r ?? []],
  mdastExtensions: [ku(), ...t ?? []]
});
export {
  bu as markdownToMdAST
};
